var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangePwd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 293.955,
    height: 288.329,
    viewBox: "0 0 293.955 288.329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Secure_login-amico",
    "data-name": "Secure login-amico",
    transform: "translate(-39.028 -37.51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-15",
    transform: "translate(40.086 174.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M124.544,357.162l54.29-31.352,43.333,24.952a28.422,28.422,0,0,1,7.725-6.291c15.458-8.928,40.43-8.928,55.792,0s15.273,23.388-.184,32.316a46.584,46.584,0,0,1-10.574,4.365l4.358,2.507a1.974,1.974,0,0,1,0,3.415l-50.355,29.085a7.862,7.862,0,0,1-7.869,0l-96.516-55.581a1.974,1.974,0,0,1,0-3.415Z",
    transform: "translate(-69.557 -265.626)",
    fill: "#e0e0e0",
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M439.713,349.214c-4.467-2.575-11.68-2.575-16.12,0s-4.413,6.762.055,9.344,11.68,2.575,16.12,0S444.18,351.8,439.713,349.214Z",
    transform: "translate(-163.599 -272.431)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M45.026,326.662l2.452,1.407a4.3,4.3,0,0,0,4.29,0L201.726,241.5a1.052,1.052,0,0,0,0-1.824l-2.425-1.4a4.283,4.283,0,0,0-4.283,0L45.026,324.831a1.059,1.059,0,0,0,0,1.831Z",
    transform: "translate(-44.499 -237.7)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-15",
    transform: "translate(238.597 37.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M393.867,78.77l-.157,60.41,3.074,1.776.157-60.417Z",
    transform: "translate(-353.69 -50.587)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M398.367,81.36h0l-.157,60.417,2.671-1.557.143-57.322Z",
    transform: "translate(-355.116 -51.408)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    height: 3.545,
    transform: "translate(40.182 28.185) rotate(-60)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M397,83.019l.007-2.48-3.074-1.769-.007,2.48L397,83.019Z",
    transform: "translate(-353.759 -50.587)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M398.43,83.84l2.152-1.236-2.145-1.243h0Z",
    transform: "translate(-355.186 -51.408)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    height: 3.545,
    transform: "translate(40.182 28.185) rotate(-60)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M339.787,46.821l2.664-1.551-.157,60.41-2.664,1.551Z",
    transform: "translate(-336.549 -39.969)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M339.63,135.261l2.664-1.551,76.967,44.433-2.671,1.551Z",
    transform: "translate(-336.549 -68)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M335.3,39.78l83.074,47.964-.178,67.466L335.12,107.246ZM415.161,149.9l.157-60.41-76.96-44.413L338.2,105.5l76.96,44.4",
    transform: "translate(-335.12 -38.229)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M335.38,39.061l2.664-1.551,83.108,47.978-2.671,1.551Z",
    transform: "translate(-335.202 -37.51)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M456.958,109.3l2.671-1.551-.178,67.466-2.671,1.551Z",
    transform: "translate(-373.679 -59.772)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Furniture--inject-15",
    transform: "translate(203.208 117.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M285.11,190.82v51.018l86.776,49.836V240.656Z",
    transform: "translate(-283.88 -166.08)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M446.378,234.94v51.018l-34.228,19.7V254.639Z",
    transform: "translate(-324.145 -180.063)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M285.11,190.82v51.018l86.776,49.836V240.656Z",
    transform: "translate(-283.88 -166.08)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M446.378,234.94v51.018l-34.228,19.7V254.639Z",
    transform: "translate(-324.145 -180.063)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M283.31,174.586l88.8,51,34.665-19.952L317.927,154.6Z",
    transform: "translate(-283.31 -154.6)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M283.31,183.86v5.212l88.8,51v-5.212Z",
    transform: "translate(-283.31 -163.874)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M447.975,229.32v5.212L413.31,254.484v-5.212Z",
    transform: "translate(-324.512 -178.282)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M447.975,229.32v5.212L413.31,254.484v-5.212Z",
    transform: "translate(-324.512 -178.282)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M405.836,228.977l19.419-11.318-18.586-10.8L387.25,218.178Z",
    transform: "translate(-316.253 -171.163)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M421,228.574l13.825-7.985-2.568-1.489-11.264,6.51Z",
    transform: "translate(-326.946 -175.043)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M434.625,219.679,420.8,227.664l-.007-2.964,11.264-6.51,2.555-1.475v-.485l-14.242,8.224.007,3.934,14.249-8.224Z",
    transform: "translate(-326.75 -174.133)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M434.625,219.679,420.8,227.664l-.007-2.964,11.264-6.51,2.555-1.475v-.485l-14.242,8.224.007,3.934,14.249-8.224Z",
    transform: "translate(-326.75 -174.133)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M434.625,219.679,420.8,227.664l-.007-2.964,11.264-6.51,2.555-1.475v-.485l-14.242,8.224.007,3.934,14.249-8.224Z",
    transform: "translate(-326.75 -174.133)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M410.849,222.739,390.33,210.82l.007,3.934,20.519,11.919Z",
    transform: "translate(-317.229 -172.418)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M410.849,222.739,390.33,210.82l.007,3.934,20.519,11.919Z",
    transform: "translate(-317.229 -172.418)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M410.849,222.739,390.33,210.82l.007,3.934,20.519,11.919Z",
    transform: "translate(-317.229 -172.418)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M410.849,218.923l14.242-8.224L404.572,198.78,390.33,207Z",
    transform: "translate(-317.229 -168.602)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M410.849,218.923l14.242-8.224L404.572,198.78,390.33,207Z",
    transform: "translate(-317.229 -168.602)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M434.426,217.26v2.978L421,227.991l-.007-2.964Z",
    transform: "translate(-326.946 -174.46)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M434.426,217.26v2.978L421,227.991l-.007-2.964Z",
    transform: "translate(-326.946 -174.46)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M423.893,232.4l.3-1.072,1.025.307c-1.141-1.1-.328-2.48-1.66-3.224l-1.318.765C423.476,230.083,422.759,231.122,423.893,232.4Z",
    transform: "translate(-327.343 -177.993)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398",
    transform: "translate(94.897 50.417)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M423.893,232.4l.3-1.072,1.025.307c-1.141-1.1-.328-2.48-1.66-3.224l-1.318.765C423.476,230.083,422.759,231.122,423.893,232.4Z",
    transform: "translate(-422.24 -228.41)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M406.293,202.768l-8.928,5.15a.362.362,0,0,0,0,.628l4.85,2.821a.936.936,0,0,0,.908,0l8.962-5.157a.362.362,0,0,0,0-.622l-4.857-2.821a.888.888,0,0,0-.936,0Z",
    transform: "translate(-319.401 -169.824)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M416.778,208.26l-9.918,5.731.779.451,9.918-5.724Z",
    transform: "translate(-322.468 -171.607)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M408.55,216.353l.779.458,5.26-3.04-.779-.451Z",
    transform: "translate(-323.004 -173.211)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M392.746,208h0l-.362-.212v.007l-3.682-2.124h0l-.362-.212,13.436-7.753,17.268,9.959-13.429,7.76Z",
    transform: "translate(-316.598 -168.263)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M388.26,209.07h0l.362.2h0L392.3,211.4h0l.362.2h0l12.869,7.425a.382.382,0,0,0-.184.307v4.658a.109.109,0,0,0,.055.109h0l-17.268-9.959h0a.116.116,0,0,1-.048-.109v-4.658A.389.389,0,0,1,388.26,209.07Z",
    transform: "translate(-316.519 -171.864)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M413.36,220.357a.383.383,0,0,1,.184-.307l13.429-7.76v.417l-13.245,7.65V224.6l13.251-7.65v.417l-13.429,7.753a.13.13,0,0,1-.13,0,.109.109,0,0,1-.055-.109Z",
    transform: "translate(-324.528 -172.884)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M392.746,208h0l-.362-.212v.007l-3.682-2.124h0l-.362-.212,13.436-7.753,17.268,9.959-13.429,7.76Z",
    transform: "translate(-316.598 -168.263)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M388.26,209.07h0l.362.2h0L392.3,211.4h0l.362.2h0l12.869,7.425a.382.382,0,0,0-.184.307v4.658a.109.109,0,0,0,.055.109h0l-17.268-9.959h0a.116.116,0,0,1-.048-.109v-4.658A.389.389,0,0,1,388.26,209.07Z",
    transform: "translate(-316.519 -171.864)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M413.36,220.357a.383.383,0,0,1,.184-.307l13.429-7.76v.417l-13.245,7.65V224.6l13.251-7.65v.417l-13.429,7.753a.13.13,0,0,1-.13,0,.109.109,0,0,1-.055-.109Z",
    transform: "translate(-324.528 -172.884)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M426.315,213.6v3.449L413.9,224.263l-.014-3.49Z",
    transform: "translate(-324.696 -173.3)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M426.315,213.6v3.449L413.9,224.263l-.014-3.49Z",
    transform: "translate(-324.696 -173.3)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M427.161,218.879l-.84-.5v.184l-12.411,7.213v.751Z",
    transform: "translate(-324.702 -174.814)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M427.161,218.879l-.84-.5v.184l-12.411,7.213v.751Z",
    transform: "translate(-324.702 -174.814)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M388.263,205.47h0l13.429-7.76,17.268,9.959v.417l-13.238,7.65v3.484l12.411-7.206v-.184l.84.5v.417L405.545,220.5a.13.13,0,0,1-.13,0h0l-17.268-9.959h0a.116.116,0,0,1-.048-.109V205.77A.389.389,0,0,1,388.263,205.47Z",
    transform: "translate(-316.522 -168.263)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M416.533,227.149l.3-1.072,1.025.307c-1.134-1.1-.328-2.479-1.653-3.224l-1.325.765C416.116,224.8,415.42,225.831,416.533,227.149Z",
    transform: "translate(-325.01 -176.329)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399",
    transform: "translate(89.87 46.831)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M416.533,227.149l.3-1.072,1.025.307c-1.134-1.1-.328-2.479-1.653-3.224l-1.325.765C416.116,224.8,415.42,225.831,416.533,227.149Z",
    transform: "translate(-414.88 -223.16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M419.6,217.529l12.52-7.227-2.322-1.352-10.2,5.895Z",
    transform: "translate(-326.503 -171.826)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M431.94,209.478l-12.52,7.227-.007-2.684,10.2-5.895,2.316-1.339v-.437l-12.9,7.452.014,3.559,12.9-7.445Z",
    transform: "translate(-326.325 -171.002)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M431.94,209.478l-12.52,7.227-.007-2.684,10.2-5.895,2.316-1.339v-.437l-12.9,7.452.014,3.559,12.9-7.445Z",
    transform: "translate(-326.325 -171.002)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M431.94,209.478l-12.52,7.227-.007-2.684,10.2-5.895,2.316-1.339v-.437l-12.9,7.452.014,3.559,12.9-7.445Z",
    transform: "translate(-326.325 -171.002)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M410.406,212.249l-18.586-10.8.014,3.559,18.586,10.8Z",
    transform: "translate(-317.701 -169.449)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M410.406,212.249l-18.586-10.8.014,3.559,18.586,10.8Z",
    transform: "translate(-317.701 -169.449)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M410.406,212.249l-18.586-10.8.014,3.559,18.586,10.8Z",
    transform: "translate(-317.701 -169.449)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M410.406,208.791l12.9-7.452-18.586-10.8-12.9,7.452Z",
    transform: "translate(-317.701 -165.991)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M410.406,208.791l12.9-7.452-18.586-10.8-12.9,7.452Z",
    transform: "translate(-317.701 -165.991)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M431.762,207.29v2.691L419.6,217l-.007-2.684Z",
    transform: "translate(-326.503 -171.3)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M431.762,207.29v2.691L419.6,217l-.007-2.684Z",
    transform: "translate(-326.503 -171.3)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M406.282,194.153l-8.087,4.638a.328.328,0,0,0,0,.567l4.4,2.555a.8.8,0,0,0,.82,0l8.081-4.665a.328.328,0,0,0,0-.567l-4.4-2.555a.82.82,0,0,0-.813.027Z",
    transform: "translate(-319.67 -167.097)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M415.782,199.14l-8.982,5.184.7.41,8.989-5.184Z",
    transform: "translate(-322.449 -168.717)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M408.32,206.463l.71.41,4.761-2.753-.7-.41Z",
    transform: "translate(-322.931 -170.165)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M424.385,212.032v-.485l-.4-.225V208.8l-2.172,1.257h0l2.555-1.475V208.1l-3.866-2.247,1.619-.936v-.437l-.355-.2v-2.281l-.963.553,1.311-.758v-.437l-18.586-10.8L390.628,198v3.559l.225.137-2.616,1.51h0a.389.389,0,0,0-.178.307v4.658a.116.116,0,0,0,.048.109h0l17.268,9.959h0a.13.13,0,0,0,.13,0l.56-.321,4.037,2.343,2.22-1.277a3.08,3.08,0,0,0,.683,1.428l.3-1.072,1.025.307a2.459,2.459,0,0,1-.683-1.434Z",
    transform: "translate(-316.509 -165.994)",
    fill: "#fff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-15",
    transform: "translate(284.67 190.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M442.724,328.39l-10.813.314L421.1,328.39c-.471,7.3.956,14.747,2.923,18.381h0a4.939,4.939,0,0,0,2.145,2.179,12.677,12.677,0,0,0,11.516,0,4.782,4.782,0,0,0,2.138-2.234C441.781,343.062,443.188,335.637,442.724,328.39Z",
    transform: "translate(-408.414 -282.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M439.575,321.044c4.235,2.452,4.255,6.414.048,8.88s-11.059,2.452-15.294,0-4.262-6.407-.048-8.88S435.34,318.6,439.575,321.044Z",
    transform: "translate(-408.454 -279.33)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M439,322.667c3.306,1.906,3.32,5,.034,6.913a13.147,13.147,0,0,1-11.933,0c-3.306-1.906-3.32-5.007-.034-6.913A13.168,13.168,0,0,1,439,322.667Z",
    transform: "translate(-409.557 -279.976)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400",
    transform: "translate(15.059 41.262)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M439,322.667c3.306,1.906,3.32,5,.034,6.913a13.147,13.147,0,0,1-11.933,0c-3.306-1.906-3.32-5.007-.034-6.913A13.168,13.168,0,0,1,439,322.667Z",
    transform: "translate(-424.616 -321.237)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M452.782,260.83c-24.372,7.978-24.59,24.283-19.126,35.895,1.366,2.35,5.581,3.613,9.228-10.827l-6.4.82,7.459-3.784,1.94-5.792-6.223.464,7.9-3.32A117.053,117.053,0,0,1,452.782,260.83Z",
    transform: "translate(-411.505 -260.83)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M452.782,260.83c-24.372,7.978-24.59,24.283-19.126,35.895,1.366,2.35,5.581,3.613,9.228-10.827l-6.4.82,7.459-3.784,1.94-5.792-6.223.464,7.9-3.32A117.053,117.053,0,0,1,452.782,260.83Z",
    transform: "translate(-411.505 -260.83)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M452.782,260.83c-24.372,7.978-24.59,24.283-19.126,35.895,1.366,2.35,5.581,3.613,9.228-10.827l-6.4.82,7.459-3.784,1.94-5.792-6.223.464,7.9-3.32A117.053,117.053,0,0,1,452.782,260.83Z",
    transform: "translate(-411.505 -260.83)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M447.261,266.8c-12.855,9.754-14.016,20.936-10.383,32.609C435.595,289.129,434.208,278.733,447.261,266.8Z",
    transform: "translate(-412.876 -262.722)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M402.57,285.07c24.023,3.415,26.94,18.531,23.75,30.26-.9,2.418-4.6,4.29-10.4-8.552l6.1-.3-7.548-2.281-2.732-5.068,5.867-.608-7.9-1.776A111.465,111.465,0,0,0,402.57,285.07Z",
    transform: "translate(-402.57 -268.513)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M402.57,285.07c24.023,3.415,26.94,18.531,23.75,30.26-.9,2.418-4.6,4.29-10.4-8.552l6.1-.3-7.548-2.281-2.732-5.068,5.867-.608-7.9-1.776A111.465,111.465,0,0,0,402.57,285.07Z",
    transform: "translate(-402.57 -268.513)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M402.57,285.07c24.023,3.415,26.94,18.531,23.75,30.26-.9,2.418-4.6,4.29-10.4-8.552l6.1-.3-7.548-2.281-2.732-5.068,5.867-.608-7.9-1.776A111.465,111.465,0,0,0,402.57,285.07Z",
    transform: "translate(-402.57 -268.513)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M413,289c13.586,6.947,16.53,17.172,15.089,28.647C427.549,307.832,427.112,297.921,413,289Z",
    transform: "translate(-405.876 -269.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M461.661,293.38c-22.035.362-26.359,13.661-24.8,24.59.54,2.281,3.661,4.378,10.321-6.544l-5.464-.956,7.083-1.209,3.06-4.262-5.225-1.2,7.329-.724a99.723,99.723,0,0,1,7.691-9.7Z",
    transform: "translate(-413.348 -271.146)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M455.7,295.72c-13.033,4.74-16.824,13.627-16.81,24.132C440.447,311.089,441.95,302.2,455.7,295.72Z",
    transform: "translate(-414.081 -271.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M461.661,293.38c-22.035.362-26.359,13.661-24.8,24.59.54,2.281,3.661,4.378,10.321-6.544l-5.464-.956,7.083-1.209,3.06-4.262-5.225-1.2,7.329-.724a99.723,99.723,0,0,1,7.691-9.7Z",
    transform: "translate(-413.348 -271.146)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-15-2",
    "data-name": "freepik--window--inject-15",
    transform: "translate(39.028 44.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M47.369,197.262l-.027-8.422-4.392-2.5.02,8.224h0l.007.191,4.392,2.507Z",
    transform: "translate(-42.95 -91.597)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M47.658,298.68l-.273-97.514L43,198.66l.273,97.322a1.837,1.837,0,0,0,.738,1.653h0l4.331,2.643A1.831,1.831,0,0,1,47.658,298.68Z",
    transform: "translate(-42.966 -95.501)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M47.658,298.68l-.273-97.514L43,198.66l.273,97.322a1.837,1.837,0,0,0,.738,1.653h0l4.331,2.643A1.831,1.831,0,0,1,47.658,298.68Z",
    transform: "translate(-42.966 -95.501)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M53.405,347.26a3.06,3.06,0,0,1-.505.239,3.06,3.06,0,0,0,.505-.239Z",
    transform: "translate(-46.104 -142.599)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M52.329,347.73h0Z",
    transform: "translate(-45.888 -142.748)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M51.044,347.59Z",
    transform: "translate(-45.505 -142.703)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M47.356,144.879v-4.85a5.717,5.717,0,0,1,2.6-4.495l146.919-84.85a1.844,1.844,0,0,1,1.824-.191l-4.337-2.664h0a1.81,1.81,0,0,0-1.878.15L45.546,132.823a5.724,5.724,0,0,0-2.6,4.495v4.85h0v.191l4.392,2.52Z",
    transform: "translate(-42.95 -47.635)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M47.356,144.879v-4.85a5.717,5.717,0,0,1,2.6-4.495l146.919-84.85a1.844,1.844,0,0,1,1.824-.191l-4.337-2.664h0a1.81,1.81,0,0,0-1.878.15L45.546,132.823a5.724,5.724,0,0,0-2.6,4.495v4.85h0v.191l4.392,2.52Z",
    transform: "translate(-42.95 -47.635)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M47.369,197.262l-.027-8.422-4.392-2.5.02,8.224h0l.007.191,4.392,2.507Z",
    transform: "translate(-42.95 -91.597)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M47.369,197.262l-.027-8.422-4.392-2.5.02,8.224h0l.007.191,4.392,2.507Z",
    transform: "translate(-42.95 -91.597)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M198.915,51.935c1.434-.826,2.609-.164,2.609,1.489v4.857L49.4,146.129v-4.85a5.717,5.717,0,0,1,2.6-4.495Z",
    transform: "translate(-44.994 -48.885)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M253.236,63.761c.772-.444,1.366-.089,1.366.792a3.081,3.081,0,0,1-1.366,2.4c-.772.444-1.366.089-1.366-.8A3.067,3.067,0,0,1,253.236,63.761Z",
    transform: "translate(-109.165 -52.686)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M259.456,60.171c.765-.444,1.366-.089,1.366.792a3.033,3.033,0,0,1-1.366,2.4c-.765.444-1.366.089-1.366-.792A3.033,3.033,0,0,1,259.456,60.171Z",
    transform: "translate(-111.137 -51.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M265.666,56.583c.765-.437,1.366-.082,1.366.8a3.081,3.081,0,0,1-1.366,2.4c-.772.444-1.366.082-1.366-.8a3.046,3.046,0,0,1,1.366-2.4Z",
    transform: "translate(-113.105 -50.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M80.007,126.758c.574-.335,1.1-.28,1.366.143l1.366,2.131c.273.423.8.485,1.366.15L201.53,61.41v8.429L49.42,157.674v-8.429l4.508-2.6a3.463,3.463,0,0,0,1.366-1.742l1.366-3.709a3.415,3.415,0,0,1,1.366-1.735Z",
    transform: "translate(-45.001 -52.001)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M201.558,73.73l.273,97.514a5.724,5.724,0,0,1-2.589,4.495L52.3,260.567c-1.441.833-2.6.164-2.609-1.482l-.273-97.514Z",
    transform: "translate(-45.001 -55.906)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401",
    transform: "translate(4.419 17.824)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M201.558,73.73l.273,97.514a5.724,5.724,0,0,1-2.589,4.495L52.3,260.567c-1.441.833-2.6.164-2.609-1.482l-.273-97.514Z",
    transform: "translate(-49.42 -73.73)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M202.728,68.883c1.018-.587,1.844-.116,1.851,1.059a4.1,4.1,0,0,1-1.844,3.19L73.958,147.476c-1.025.587-1.858.116-1.858-1.059a4.044,4.044,0,0,1,1.844-3.19Z",
    transform: "translate(-52.189 -54.29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M52.29,191.087a.178.178,0,0,1,.191,0c.1.068.089.26,0,.43l-.813,1.325,2.131-1.23a.164.164,0,0,1,.266.143.594.594,0,0,1-.266.458l-2.131,1.229.82.383c.1.055.109.239,0,.417a.56.56,0,0,1-.191.2.191.191,0,0,1-.178,0l-1.3-.628-.055-.048h0v-.239h0l.048-.109,1.3-2.131a.423.423,0,0,1,.178-.2Z",
    transform: "translate(-45.425 -93.092)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M58.907,187.19a.191.191,0,0,1,.178,0l1.311.622.048.061h0v.239h0l-.048.1-1.3,2.145a.629.629,0,0,1-.178.178.178.178,0,0,1-.191,0c-.1-.061-.1-.253,0-.43l.806-1.325-2.131,1.23a.157.157,0,0,1-.26-.15.567.567,0,0,1,.26-.444l2.131-1.23-.813-.389c-.109-.055-.116-.239,0-.417A.5.5,0,0,1,58.907,187.19Z",
    transform: "translate(-47.446 -91.859)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M65.475,183.219a1.168,1.168,0,0,1,.881-.164l.191-.253a.492.492,0,0,1,.143-.13.191.191,0,0,1,.143-.034c.089,0,.13.1.116.232l-.109.8a.6.6,0,0,1-.253.4H66.52l-.635.178a.15.15,0,0,1-.191-.13.506.506,0,0,1,.116-.369l.061-.082a.786.786,0,0,0-.4.123,2.049,2.049,0,0,0-.936,1.619c0,.594.423.833.943.533a2.049,2.049,0,0,0,.82-1.031.608.608,0,0,1,.225-.287.307.307,0,0,1,.13-.034c.123,0,.171.164.1.348a3.211,3.211,0,0,1-1.277,1.605c-.8.458-1.462.089-1.462-.833A3.217,3.217,0,0,1,65.475,183.219Z",
    transform: "translate(-49.628 -90.423)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    transform: "translate(-82.89 71.319) rotate(-34)",
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M14.135,14.135A14.844,14.844,0,0,1,0,0,14.845,14.845,0,0,1,14.135,14.135",
    transform: "translate(179.744 118.829) rotate(101)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M36.628,36.628A38.466,38.466,0,0,1,0,0,38.467,38.467,0,0,1,36.628,36.628",
    transform: "translate(185.554 137.231) rotate(101)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M36.629,36.629A38.466,38.466,0,0,1,0,0,38.467,38.467,0,0,1,36.629,36.629",
    transform: "translate(52.218 111.606) rotate(-79)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M14.135,14.135A14.844,14.844,0,0,1,0,0,14.845,14.845,0,0,1,14.135,14.135",
    transform: "translate(59.32 130.008) rotate(-79)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    transform: "translate(5.335 97.967)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M52.29,191.087a.178.178,0,0,1,.191,0c.1.068.089.26,0,.43l-.813,1.325,2.131-1.23a.164.164,0,0,1,.266.143.594.594,0,0,1-.266.458l-2.131,1.229.82.383c.1.055.109.239,0,.417a.56.56,0,0,1-.191.2.191.191,0,0,1-.178,0l-1.3-.628-.055-.048h0v-.239h0l.048-.109,1.3-2.131a.423.423,0,0,1,.178-.2Z",
    transform: "translate(-50.76 -191.059)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403",
    transform: "translate(9.689 95.309)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M58.907,187.19a.191.191,0,0,1,.178,0l1.311.622.048.061h0v.239h0l-.048.1-1.3,2.145a.629.629,0,0,1-.178.178.178.178,0,0,1-.191,0c-.1-.061-.1-.253,0-.43l.806-1.325-2.131,1.23a.157.157,0,0,1-.26-.15.567.567,0,0,1,.26-.444l2.131-1.23-.813-.389c-.109-.055-.116-.239,0-.417A.5.5,0,0,1,58.907,187.19Z",
    transform: "translate(-57.134 -187.168)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404",
    transform: "translate(14.392 92.214)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M65.475,183.219a1.168,1.168,0,0,1,.881-.164l.191-.253a.492.492,0,0,1,.143-.13.191.191,0,0,1,.143-.034c.089,0,.13.1.116.232l-.109.8a.6.6,0,0,1-.253.4H66.52l-.635.178a.15.15,0,0,1-.191-.13.506.506,0,0,1,.116-.369l.061-.082a.786.786,0,0,0-.4.123,2.049,2.049,0,0,0-.936,1.619c0,.594.423.833.943.533a2.049,2.049,0,0,0,.82-1.031.608.608,0,0,1,.225-.287.307.307,0,0,1,.13-.034c.123,0,.171.164.1.348a3.211,3.211,0,0,1-1.277,1.605c-.8.458-1.462.089-1.462-.833A3.217,3.217,0,0,1,65.475,183.219Z",
    transform: "translate(-64.02 -182.636)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    transform: "translate(18.34 34.655)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M220.229,216.958l-.642,1.482L214.3,221.5l.02,7.807,9.87-5.7-.02-7.4-.007-.4V214.69Z",
    transform: "translate(-115.598 -135.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M224.2,230.614l-9.87,5.7v-.881l9.87-5.7Z",
    transform: "translate(-115.607 -140.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M226.352,232.42v.874l-5.232,3.019v-.874Z",
    transform: "translate(-117.759 -140.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M224.2,230.614l-9.87,5.7v-.881l9.87-5.7Z",
    transform: "translate(-115.607 -140.007)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M226.352,232.42v.874l-5.232,3.019v-.874Z",
    transform: "translate(-117.759 -140.856)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M220.229,183.638l-.642,1.489L214.3,188.18l.02,7.807,9.87-5.7-.02-7.411-.007-.4V181.37Z",
    transform: "translate(-115.598 -124.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M224.2,197.3l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-115.607 -129.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M226.352,199.1v.881L221.12,203v-.881Z",
    transform: "translate(-117.759 -130.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M224.2,197.3l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-115.607 -129.449)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M226.352,199.1v.881L221.12,203v-.881Z",
    transform: "translate(-117.759 -130.295)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M220.229,150.328l-.642,1.482-5.287,3.06.02,7.807,9.87-5.7-.02-7.411-.007-.4V148.06Z",
    transform: "translate(-115.598 -114.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M224.2,163.991l-9.87,5.7v-.881l9.87-5.7Z",
    transform: "translate(-115.607 -118.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M226.352,165.79v.874l-5.232,3.019v-.874Z",
    transform: "translate(-117.759 -119.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M224.2,163.991l-9.87,5.7v-.881l9.87-5.7Z",
    transform: "translate(-115.607 -118.889)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M226.352,165.79v.874l-5.232,3.019v-.874Z",
    transform: "translate(-117.759 -119.738)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M220.229,117.015l-.642,1.482L214.3,121.55l.02,7.807,9.87-5.7-.02-7.411-.007-.4V114.74Z",
    transform: "translate(-115.598 -103.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M224.2,130.674l-9.87,5.7V135.5l9.87-5.7Z",
    transform: "translate(-115.607 -108.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M226.352,132.47v.881l-5.232,3.019V135.5Z",
    transform: "translate(-117.759 -109.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M224.2,130.674l-9.87,5.7V135.5l9.87-5.7Z",
    transform: "translate(-115.607 -108.331)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M226.352,132.47v.881l-5.232,3.019V135.5Z",
    transform: "translate(-117.759 -109.178)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M248.5,200.578l-.642,1.489-5.294,3.053.02,7.807,9.87-5.7-.02-7.411v-.4l-.007-1.113Z",
    transform: "translate(-124.555 -130.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M252.46,214.244l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-124.564 -134.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M254.612,216.04v.874l-5.232,3.026v-.881Z",
    transform: "translate(-126.716 -135.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M252.46,214.244l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-124.564 -134.818)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M254.612,216.04v.874l-5.232,3.026v-.881Z",
    transform: "translate(-126.716 -135.664)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M248.5,167.268l-.642,1.482-5.294,3.06.02,7.807,9.87-5.7-.02-7.4v-.4L252.423,165Z",
    transform: "translate(-124.555 -119.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M252.46,180.931l-9.87,5.7v-.881l9.87-5.7Z",
    transform: "translate(-124.564 -124.258)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M254.612,182.73v.874l-5.232,3.019v-.874Z",
    transform: "translate(-126.716 -125.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M252.46,180.931l-9.87,5.7v-.881l9.87-5.7Z",
    transform: "translate(-124.564 -124.258)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M254.612,182.73v.874l-5.232,3.019v-.874Z",
    transform: "translate(-126.716 -125.107)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M248.5,133.955l-.642,1.482-5.294,3.053.02,7.807,9.87-5.7-.02-7.411v-.4l-.007-1.113Z",
    transform: "translate(-124.555 -108.927)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M252.46,147.614l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-124.564 -113.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M254.612,149.41v.881l-5.232,3.019v-.874Z",
    transform: "translate(-126.716 -114.547)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M252.46,147.614l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-124.564 -113.7)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M254.612,149.41v.881l-5.232,3.019v-.874Z",
    transform: "translate(-126.716 -114.547)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M248.5,100.638l-.642,1.482-5.294,3.06.02,7.807,9.87-5.7-.02-7.411v-.4l-.007-1.113Z",
    transform: "translate(-124.555 -98.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M252.46,114.3l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-124.564 -103.14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M254.612,116.1v.874l-5.232,3.019v-.874Z",
    transform: "translate(-126.716 -103.989)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M252.46,114.3l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-124.564 -103.14)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M254.612,116.1v.874l-5.232,3.019v-.874Z",
    transform: "translate(-126.716 -103.989)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M191.329,233.715l-.635,1.482L185.4,238.25l.02,7.807,9.87-5.7-.02-7.411-.007-.4V231.44Z",
    transform: "translate(-106.438 -140.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M195.3,247.374l-9.87,5.7V252.2l9.87-5.7Z",
    transform: "translate(-106.448 -145.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M197.452,249.17v.881l-5.232,3.019v-.881Z",
    transform: "translate(-108.6 -146.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M195.3,247.374l-9.87,5.7V252.2l9.87-5.7Z",
    transform: "translate(-106.448 -145.318)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M197.452,249.17v.881l-5.232,3.019v-.881Z",
    transform: "translate(-108.6 -146.165)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M191.329,200.4l-.635,1.489L185.4,204.94l.02,7.807,9.87-5.7-.02-7.411-.007-.4V198.13Z",
    transform: "translate(-106.438 -129.988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M195.3,214.061l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-106.448 -134.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M197.452,215.86v.874l-5.232,3.019v-.874Z",
    transform: "translate(-108.6 -135.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M195.3,214.061l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-106.448 -134.758)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M197.452,215.86v.874l-5.232,3.019v-.874Z",
    transform: "translate(-108.6 -135.607)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M191.329,167.085l-.635,1.482L185.4,171.62l.02,7.807,9.87-5.7-.02-7.4-.007-.4V164.81Z",
    transform: "translate(-106.438 -119.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M195.3,180.744l-9.87,5.7v-.881l9.87-5.7Z",
    transform: "translate(-106.448 -124.201)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M197.452,182.55v.874l-5.232,3.019v-.874Z",
    transform: "translate(-108.6 -125.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M195.3,180.744l-9.87,5.7v-.881l9.87-5.7Z",
    transform: "translate(-106.448 -124.201)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M197.452,182.55v.874l-5.232,3.019v-.874Z",
    transform: "translate(-108.6 -125.05)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M191.329,133.768l-.635,1.489L185.4,138.31l.02,7.807,9.87-5.7-.02-7.411-.007-.4V131.5Z",
    transform: "translate(-106.438 -108.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M195.3,147.434l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-106.448 -113.643)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M197.452,149.23v.874l-5.232,3.026v-.881Z",
    transform: "translate(-108.6 -114.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M195.3,147.434l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-106.448 -113.643)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M197.452,149.23v.874l-5.232,3.026v-.881Z",
    transform: "translate(-108.6 -114.49)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M162.436,250.468l-.642,1.489L156.5,255.01l.021,7.807,9.87-5.7-.021-7.411v-.4l-.007-1.113Z",
    transform: "translate(-97.279 -145.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M166.4,264.131l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-97.288 -150.627)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M168.552,265.93v.874l-5.232,3.019v-.874Z",
    transform: "translate(-99.44 -151.477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M166.4,264.131l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-97.288 -150.627)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M168.552,265.93v.874l-5.232,3.019v-.874Z",
    transform: "translate(-99.44 -151.477)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M162.436,217.158l-.642,1.482L156.5,221.7l.021,7.8,9.87-5.7-.021-7.4V216l-.007-1.107Z",
    transform: "translate(-97.279 -135.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M166.4,230.814l-9.87,5.7v-.881l9.87-5.7Z",
    transform: "translate(-97.288 -140.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M168.552,232.62v.874l-5.232,3.019v-.874Z",
    transform: "translate(-99.44 -140.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M166.4,230.814l-9.87,5.7v-.881l9.87-5.7Z",
    transform: "translate(-97.288 -140.07)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M168.552,232.62v.874l-5.232,3.019v-.874Z",
    transform: "translate(-99.44 -140.919)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M162.436,183.845l-.642,1.482L156.5,188.38l.021,7.807,9.87-5.7-.021-7.411v-.4l-.007-1.113Z",
    transform: "translate(-97.279 -124.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M166.4,197.5l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-97.288 -129.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M168.552,199.3v.881L163.32,203.2v-.881Z",
    transform: "translate(-99.44 -130.359)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M166.4,197.5l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-97.288 -129.513)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M168.552,199.3v.881L163.32,203.2v-.881Z",
    transform: "translate(-99.44 -130.359)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M162.436,150.528l-.642,1.482-5.294,3.06.021,7.807,9.87-5.7-.021-7.411v-.4l-.007-1.113Z",
    transform: "translate(-97.279 -114.182)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M166.4,164.191l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-97.288 -118.952)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M168.552,165.99v.874l-5.232,3.019v-.874Z",
    transform: "translate(-99.44 -119.802)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M166.4,164.191l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-97.288 -118.952)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M168.552,165.99v.874l-5.232,3.019v-.874Z",
    transform: "translate(-99.44 -119.802)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M133.536,267.228l-.642,1.482-5.294,3.06.02,7.807,9.87-5.7-.02-7.4v-.4l-.007-1.113Z",
    transform: "translate(-88.119 -151.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M137.5,280.891l-9.87,5.7v-.881l9.87-5.7Z",
    transform: "translate(-88.129 -155.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M139.652,282.69v.874l-5.232,3.019v-.874Z",
    transform: "translate(-90.281 -156.789)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M137.5,280.891l-9.87,5.7v-.881l9.87-5.7Z",
    transform: "translate(-88.129 -155.939)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M139.652,282.69v.874l-5.232,3.019v-.874Z",
    transform: "translate(-90.281 -156.789)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M133.536,233.915l-.642,1.482L127.6,238.45l.02,7.807,9.87-5.7-.02-7.411v-.4l-.007-1.113Z",
    transform: "translate(-88.119 -140.609)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M137.5,247.574l-9.87,5.7V252.4l9.87-5.7Z",
    transform: "translate(-88.129 -145.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M139.652,249.37v.881l-5.232,3.019v-.881Z",
    transform: "translate(-90.281 -146.228)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M137.5,247.574l-9.87,5.7V252.4l9.87-5.7Z",
    transform: "translate(-88.129 -145.382)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M139.652,249.37v.881l-5.232,3.019v-.881Z",
    transform: "translate(-90.281 -146.228)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M133.536,200.6l-.642,1.489L127.6,205.14l.02,7.807,9.87-5.7-.02-7.411v-.4l-.007-1.113Z",
    transform: "translate(-88.119 -130.051)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M137.5,214.261l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-88.129 -134.821)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M139.652,216.06v.874l-5.232,3.019v-.874Z",
    transform: "translate(-90.281 -135.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M137.5,214.261l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-88.129 -134.821)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M139.652,216.06v.874l-5.232,3.019v-.874Z",
    transform: "translate(-90.281 -135.671)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M133.536,167.288l-.642,1.482-5.294,3.06.02,7.8,9.87-5.7-.02-7.4v-.4l-.007-1.107Z",
    transform: "translate(-88.119 -119.494)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M137.5,180.944l-9.87,5.7v-.881l9.87-5.7Z",
    transform: "translate(-88.129 -124.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M139.652,182.75v.874l-5.232,3.019v-.874Z",
    transform: "translate(-90.281 -125.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M137.5,180.944l-9.87,5.7v-.881l9.87-5.7Z",
    transform: "translate(-88.129 -124.264)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M139.652,182.75v.874l-5.232,3.019v-.874Z",
    transform: "translate(-90.281 -125.113)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M104.636,283.985l-.642,1.482-5.294,3.06.021,7.8,9.87-5.7-.02-7.4v-.4l-.007-1.113Z",
    transform: "translate(-78.96 -156.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M108.6,297.644l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-78.969 -161.251)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M110.752,299.45v.874l-5.232,3.019v-.874Z",
    transform: "translate(-81.121 -162.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M108.6,297.644l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-78.969 -161.251)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M110.752,299.45v.874l-5.232,3.019v-.874Z",
    transform: "translate(-81.121 -162.1)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M104.636,250.668l-.642,1.489L98.7,255.21l.021,7.807,9.87-5.7-.02-7.411v-.4l-.007-1.113Z",
    transform: "translate(-78.96 -145.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M108.6,264.334l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-78.969 -150.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M110.752,266.13v.881l-5.232,3.019v-.881Z",
    transform: "translate(-81.121 -151.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M108.6,264.334l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-78.969 -150.694)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M110.752,266.13v.881l-5.232,3.019v-.881Z",
    transform: "translate(-81.121 -151.54)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M104.636,217.358l-.642,1.482L98.7,221.9l.021,7.807,9.87-5.7-.02-7.4v-.4l-.007-1.113Z",
    transform: "translate(-78.96 -135.363)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M108.6,231.021l-9.87,5.7v-.881l9.87-5.7Z",
    transform: "translate(-78.969 -140.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M110.752,232.82v.874l-5.232,3.019v-.874Z",
    transform: "translate(-81.121 -140.983)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M108.6,231.021l-9.87,5.7v-.881l9.87-5.7Z",
    transform: "translate(-78.969 -140.133)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M110.752,232.82v.874l-5.232,3.019v-.874Z",
    transform: "translate(-81.121 -140.983)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M104.636,184.045l-.642,1.482L98.7,188.58l.021,7.807,9.87-5.7-.02-7.411v-.4l-.007-1.113Z",
    transform: "translate(-78.96 -124.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M108.6,197.7l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-78.969 -129.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M110.752,199.5v.881L105.52,203.4v-.874Z",
    transform: "translate(-81.121 -130.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M108.6,197.7l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-78.969 -129.576)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M110.752,199.5v.881L105.52,203.4v-.874Z",
    transform: "translate(-81.121 -130.422)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M75.736,300.745l-.642,1.482L69.8,305.28l.02,7.807,9.87-5.7-.02-7.411v-1.51Z",
    transform: "translate(-69.8 -161.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M79.7,314.4l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-69.81 -166.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M81.855,316.2v.881L76.63,320.1v-.881Z",
    transform: "translate(-71.965 -167.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M79.7,314.4l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-69.81 -166.563)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M81.855,316.2v.881L76.63,320.1v-.881Z",
    transform: "translate(-71.965 -167.409)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M75.736,267.428l-.642,1.482L69.8,271.97l.02,7.807,9.87-5.7-.02-7.411v-1.51Z",
    transform: "translate(-69.8 -151.233)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M79.7,281.091l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-69.81 -156.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M81.855,282.89v.874l-5.225,3.019v-.874Z",
    transform: "translate(-71.965 -156.852)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M79.7,281.091l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-69.81 -156.003)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M81.855,282.89v.874l-5.225,3.019v-.874Z",
    transform: "translate(-71.965 -156.852)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M75.736,234.115l-.642,1.482L69.8,238.65l.02,7.807,9.87-5.7-.02-7.4V231.84Z",
    transform: "translate(-69.8 -140.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M79.7,247.774l-9.87,5.7V252.6l9.87-5.7Z",
    transform: "translate(-69.81 -145.445)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M81.855,249.57v.881L76.63,253.47V252.6Z",
    transform: "translate(-71.965 -146.291)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M79.7,247.774l-9.87,5.7V252.6l9.87-5.7Z",
    transform: "translate(-69.81 -145.445)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M81.855,249.57v.881L76.63,253.47V252.6Z",
    transform: "translate(-71.965 -146.291)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M75.736,200.8l-.642,1.489L69.8,205.34l.02,7.807,9.87-5.7-.02-7.411v-1.51Z",
    transform: "translate(-69.8 -130.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M79.7,214.464l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-69.81 -134.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M81.855,216.26v.874L76.63,220.16v-.881Z",
    transform: "translate(-71.965 -135.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M79.7,214.464l-9.87,5.7v-.874l9.87-5.7Z",
    transform: "translate(-69.81 -134.888)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M81.855,216.26v.874L76.63,220.16v-.881Z",
    transform: "translate(-71.965 -135.734)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M198.415,125.582h0a4.426,4.426,0,0,0-3.682-2.432,1.632,1.632,0,0,0-.485.1l-68.306,39.228a3.217,3.217,0,0,0-1.612,2.766v51.12a3.045,3.045,0,0,0,4.1,2.732h0a.526.526,0,0,0,.13-.055l68.306-39.255a3.2,3.2,0,0,0,1.605-2.773V125.93A.868.868,0,0,0,198.415,125.582Z",
    transform: "translate(-68.743 -71.569)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M124.34,184.123v51.12a3.045,3.045,0,0,0,4.1,2.732h0a.792.792,0,0,1-1.066-.745V186.118a3.21,3.21,0,0,1,.54-1.762l-3.265-1.626a3.217,3.217,0,0,0-.307,1.393Z",
    transform: "translate(-68.746 -90.452)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M194.885,123.15a1.632,1.632,0,0,0-.485.1l-68.306,39.228a3.19,3.19,0,0,0-1.284,1.366l3.265,1.626a3.306,3.306,0,0,1,1.072-1.011l68.306-39.221a.792.792,0,0,1,1.107.342h0A4.426,4.426,0,0,0,194.885,123.15Z",
    transform: "translate(-68.895 -71.569)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    transform: "translate(63.497 92.998)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M196.484,184.014c.929-.533,1.687-.1,1.687.963v7.978a3.7,3.7,0,0,1-1.673,2.91l-58.9,34c-.922.533-1.68.1-1.687-.97v-7.971a3.716,3.716,0,0,1,1.68-2.91Z",
    transform: "translate(-135.91 -183.785)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M158.946,224.76,158.926,226l.956-1.223.533.7-.929,1.127.936.041-.533,1.318-.956-.109.027,1.189-1.038.6.02-1.223-.956,1.216-.526-.7.929-1.12-.929-.048.519-1.311.956.123-.027-1.2Z",
    transform: "translate(-78.926 -103.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M165.273,221.11l-.02,1.236.956-1.23.533.7-.929,1.127.936.041-.533,1.311-.963-.109.034,1.2-1.038.6.02-1.223-.956,1.216-.526-.71.929-1.113-.936-.048.519-1.311.963.116-.027-1.2Z",
    transform: "translate(-80.929 -102.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M171.6,217.46l-.027,1.236.963-1.23.533.7-.936,1.127.936.041-.526,1.311-.963-.109.034,1.2-1.045.6.027-1.23-.956,1.216-.526-.7.929-1.113-.936-.055.519-1.3.963.116-.034-1.2Z",
    transform: "translate(-82.935 -101.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M177.933,213.81l-.027,1.23.963-1.223.526.7-.929,1.127.936.041-.526,1.311-.963-.1.027,1.189-1.038.6.02-1.223-.956,1.216-.526-.7.936-1.12-.936-.048.519-1.311.956.123-.027-1.2Z",
    transform: "translate(-84.941 -100.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M184.256,210.15l-.02,1.236.956-1.229.533.7-.929,1.127.936.041-.533,1.311-.963-.109.034,1.2-1.038.6.02-1.223-.956,1.216-.526-.71.929-1.113-.929-.055.512-1.3.963.116-.027-1.2Z",
    transform: "translate(-86.948 -99.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M190.583,206.5l-.02,1.236.956-1.23.533.7-.929,1.127.929.041-.526,1.311-.963-.109.034,1.2-1.045.6.027-1.223-.956,1.216-.526-.71.929-1.113-.936-.055.519-1.3.963.116-.034-1.2Z",
    transform: "translate(-88.951 -97.986)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M196.913,202.85l-.027,1.236.963-1.23.533.7-.936,1.127.936.041-.526,1.311-.963-.1.027,1.189-1.038.6.027-1.223-.963,1.216-.526-.7.936-1.12-.936-.048.519-1.3.963.116-.034-1.2Z",
    transform: "translate(-90.957 -96.829)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M203.243,199.19l-.027,1.236.956-1.223.533.7-.929,1.127.936.041-.533,1.311-.956-.109.027,1.2-1.038.6.02-1.223-.956,1.216-.526-.71.929-1.113-.929-.048.519-1.311.956.123-.027-1.209Z",
    transform: "translate(-92.963 -95.669)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M178.988,196.15h.089l-.546,4.672h0l.54-4.672Z",
    transform: "translate(-85.921 -94.706)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M180.848,189.314a1.523,1.523,0,0,0-1.025.232A4.051,4.051,0,0,0,178,192.716a2.049,2.049,0,0,0,.068.519.97.97,0,0,0,.758.745h.089l-.54,4.672,2.958-1.708-.567-4.037a4.379,4.379,0,0,0,.683-1.134,3.375,3.375,0,0,0,.246-1.2,1.8,1.8,0,0,0-.143-.738A.943.943,0,0,0,180.848,189.314Z",
    transform: "translate(-85.753 -92.535)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M180.848,189.314a1.523,1.523,0,0,0-1.025.232A4.051,4.051,0,0,0,178,192.716a2.049,2.049,0,0,0,.068.519.97.97,0,0,0,.758.745h.089l-.54,4.672,2.958-1.708-.567-4.037a4.379,4.379,0,0,0,.683-1.134,3.375,3.375,0,0,0,.246-1.2,1.8,1.8,0,0,0-.143-.738A.943.943,0,0,0,180.848,189.314Z",
    transform: "translate(-85.753 -92.535)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M166,188.481v13.163l20.041-11.571L186,176.91Zm11.612-.608a4.379,4.379,0,0,1-.683,1.134l.567,4.037-2.958,1.708h0l.546-4.672H175a.97.97,0,0,1-.758-.745,2.049,2.049,0,0,1-.068-.519A4.051,4.051,0,0,1,176,185.646a1.523,1.523,0,0,1,1.025-.232.943.943,0,0,1,.683.546,1.8,1.8,0,0,1,.143.738,3.374,3.374,0,0,1-.239,1.2Z",
    transform: "translate(-81.95 -88.608)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M166,188.481v13.163l20.041-11.571L186,176.91Zm11.612-.608a4.379,4.379,0,0,1-.683,1.134l.567,4.037-2.958,1.708h0l.546-4.672H175a.97.97,0,0,1-.758-.745,2.049,2.049,0,0,1-.068-.519A4.051,4.051,0,0,1,176,185.646a1.523,1.523,0,0,1,1.025-.232.943.943,0,0,1,.683.546,1.8,1.8,0,0,1,.143.738,3.374,3.374,0,0,1-.239,1.2Z",
    transform: "translate(-81.95 -88.608)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M171.439,180.9v-6.339A12.266,12.266,0,0,1,176.944,165c3.046-1.783,5.533-.342,5.546,3.156v4.2l2.391-1.366v-4.2c0-5.021-3.572-7.049-7.944-4.529S169,170.925,169,175.939v6.339Z",
    transform: "translate(-82.9 -83.621)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M171.439,180.9v-6.339A12.266,12.266,0,0,1,176.944,165c3.046-1.783,5.533-.342,5.546,3.156v4.2l2.391-1.366v-4.2c0-5.021-3.572-7.049-7.944-4.529S169,170.925,169,175.939v6.339Z",
    transform: "translate(-82.9 -83.621)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M185.91,179.261l-2.049,1.209a.683.683,0,0,0-.3.512c0,.2.137.273.3.171l2.1-1.209a.683.683,0,0,0,.3-.512A.217.217,0,0,0,185.91,179.261Z",
    transform: "translate(-87.515 -89.34)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M186.748,177.26c.082-.212,0-.389-.109-.4l-1.844-.157a.314.314,0,0,0-.15.041.683.683,0,0,0-.26.321c-.082.219,0,.4.116.41l1.81.157a.314.314,0,0,0,.15-.041.642.642,0,0,0,.287-.328Z",
    transform: "translate(-87.766 -88.541)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M193.434,173.109a.683.683,0,0,0,.15-.137l1.81-2.254a.5.5,0,0,0,.109-.533.184.184,0,0,0-.26,0,.464.464,0,0,0-.15.137l-1.81,2.247a.505.505,0,0,0-.109.533A.211.211,0,0,0,193.434,173.109Z",
    transform: "translate(-90.552 -86.46)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M195.988,173.439l-2.124,1.209a.642.642,0,0,0-.294.519c0,.191.13.266.294.171l2.1-1.209a.683.683,0,0,0,.3-.519.184.184,0,0,0-.273-.171Z",
    transform: "translate(-90.688 -87.501)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407",
    transform: "translate(96.045 83.672)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M185.91,179.261l-2.049,1.209a.683.683,0,0,0-.3.512c0,.2.137.273.3.171l2.1-1.209a.683.683,0,0,0,.3-.512A.217.217,0,0,0,185.91,179.261Z",
    transform: "translate(-183.56 -173.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M186.748,177.26c.082-.212,0-.389-.109-.4l-1.844-.157a.314.314,0,0,0-.15.041.683.683,0,0,0-.26.321c-.082.219,0,.4.116.41l1.81.157a.314.314,0,0,0,.15-.041.642.642,0,0,0,.287-.328Z",
    transform: "translate(-183.811 -172.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M193.434,173.109a.683.683,0,0,0,.15-.137l1.81-2.254a.5.5,0,0,0,.109-.533.184.184,0,0,0-.26,0,.464.464,0,0,0-.15.137l-1.81,2.247a.505.505,0,0,0-.109.533A.211.211,0,0,0,193.434,173.109Z",
    transform: "translate(-186.597 -170.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M195.988,173.439l-2.124,1.209a.642.642,0,0,0-.294.519c0,.191.13.266.294.171l2.1-1.209a.683.683,0,0,0,.3-.519.184.184,0,0,0-.273-.171Z",
    transform: "translate(-186.733 -171.173)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M8.972,8.972A9.422,9.422,0,0,1,0,0,9.422,9.422,0,0,1,8.972,8.972",
    transform: "translate(133.16 103.057) rotate(101)",
    fill: "#b5e3ee",
    fillRule: "evenodd",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M23.248,23.248A24.415,24.415,0,0,1,0,0,24.415,24.415,0,0,1,23.248,23.248",
    transform: "translate(136.848 114.736) rotate(101)",
    fill: "#b5e3ee",
    fillRule: "evenodd",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M23.249,23.249A24.415,24.415,0,0,1,0,0,24.416,24.416,0,0,1,23.249,23.249",
    transform: "translate(52.218 98.472) rotate(-79)",
    fill: "#b5e3ee",
    fillRule: "evenodd",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M8.972,8.972A9.422,9.422,0,0,1,0,0,9.422,9.422,0,0,1,8.972,8.972",
    transform: "translate(56.726 110.152) rotate(-79)",
    fill: "#b5e3ee",
    fillRule: "evenodd",
    opacity: 0.65
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-15",
    transform: "translate(105.688 113.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M348.439,365.676a6.585,6.585,0,0,0-2.4-4.713v-2.917L330.475,348.8l8.2-2.049a5.888,5.888,0,0,0-.874,2.924,2.008,2.008,0,0,0,.915,1.913h0l1.844,1.175h.034a2.09,2.09,0,0,0,2.049-.212,6.489,6.489,0,0,0,2.937-5.1,2.049,2.049,0,0,0-.826-1.865h0l-1.872-1.182h0a1.715,1.715,0,0,0-1.366-.137V343.8l-1-.342-13.34.683v-2.357a3.9,3.9,0,0,0,.417-.2,2.247,2.247,0,0,0,1.325-1.831V324.33h-8.948v15.423a2.192,2.192,0,0,0,1.3,1.831,4.3,4.3,0,0,0,.437.212v1.981l-9.638-2.083-.512.171v1.776h0l-1.872,1.189h0a2.117,2.117,0,0,0-.826,1.872,6.407,6.407,0,0,0,1.455,3.75l-9.317,4.2v2.24a3.991,3.991,0,0,0-.382.191,6.469,6.469,0,0,0-2.937,5.089,2.008,2.008,0,0,0,.915,1.913h0l1.837,1.175h.041a2.111,2.111,0,0,0,2.049-.219,6.482,6.482,0,0,0,2.937-5.1,2.049,2.049,0,0,0-.826-1.865h0l-.546-.342,17.657-7.179a1.284,1.284,0,0,0,.683,1.031l-1.592,13.887v1.885A6.53,6.53,0,0,0,318.4,372.1a2.049,2.049,0,0,0,.915,1.919h0l1.844,1.175h.034a2.1,2.1,0,0,0,2.049-.219,6.469,6.469,0,0,0,2.937-5.089,2.049,2.049,0,0,0-.826-1.865h0l-1.872-1.189h0a1.558,1.558,0,0,0-.977-.212l2.049-14.474h0a4.438,4.438,0,0,0,1.291-.2h0l16.578,9.051-.956.608h0a2.1,2.1,0,0,0-.826,1.865,6.469,6.469,0,0,0,2.944,5.1,2.111,2.111,0,0,0,2.049.219h.041l1.837-1.175h0A2.049,2.049,0,0,0,348.439,365.676ZM316.028,346.55l1.366.738-.943.424a6.432,6.432,0,0,0-.458-1.168Zm-11.988,7.609,6.749-3.005h0l-9.119,4.064Zm12.5-5.574h0l5.082-2.261Z",
    transform: "translate(-190.338 -204.672)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M372.772,207.458a3.764,3.764,0,0,0-.567-.956,7.877,7.877,0,0,0-.779-.806,13.966,13.966,0,0,0-1.27-1.031,15.35,15.35,0,0,0-1.551-1,15.67,15.67,0,0,0-2.486-1.127q-.492-.178-.984-.307c-.335-.1-.683-.178-1.011-.246C352.533,196.256,328.831,186,328.831,186c-8.784-3.634-11.489-.724-13.361,1.25-1.4,1.482-2.22,4.488-2.193,8.75a42.306,42.306,0,0,0,.321,4.665c.369,2.958,1.127,7.93,1.291,13.163a55.107,55.107,0,0,1-.1,5.622c-.376,4.781-1.578,9.324-4.413,12.1-4.194,4.1-17.077,1.68-23.34.184h-.089c-1.749-.423-2.958-.765-3.292-.861h-.109c-3.067-1.68-6.94-.1-6.585,3.026a3.666,3.666,0,0,0,.137.683.876.876,0,0,0,.075.239,6.346,6.346,0,0,0,.827,1.564c1.749,2.486,3.067,3.32,3.914,5.342.1.239.191.492.28.772.567,1.79.861,4.474.854,9.324l-3.347,1.721a4.932,4.932,0,0,0-1.7,1.639,8.238,8.238,0,0,0-1.25,4.228,8.99,8.99,0,0,0,.225,2.3,7.444,7.444,0,0,0,.2.738,6.182,6.182,0,0,0,2.732,3.49l36.475,19.378a8.518,8.518,0,0,0,6.913.485,8.872,8.872,0,0,0,.949-.41L349.8,272.451a12.917,12.917,0,0,0,6.639-8.163l14.631-54.05a2.049,2.049,0,0,0,1.366-.622,1.8,1.8,0,0,0,.417-1v-.28a2.616,2.616,0,0,0-.082-.874ZM321,201.051a2.635,2.635,0,0,1,.1-.505c.055-.328.116-.649.178-.977-.055.294-.109.581-.157.874s-.082.4-.116.608-.1.622-.137.929a3.128,3.128,0,0,1-.068.43l.061-.4C320.908,201.693,320.949,201.372,321,201.051Zm2.131-7.835a30.2,30.2,0,0,0-1,2.876c.143-.485.294-.956.458-1.421.068-.212.15-.41.232-.615s.2-.567.314-.84.2-.464.314-.683.164-.4.26-.581c-.068.137-.13.287-.191.43a7.738,7.738,0,0,0-.383.833ZM323.749,191.85ZM321.318,199.4Zm29.563,63.477a11.443,11.443,0,0,1-1.011.587c.328-.164.642-.355.956-.546Zm-35.867-18.381,13.818,7.1-13.8-7.1Z",
    transform: "translate(-183.708 -160.28)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M298.508,364.084h0l1.844,1.175h0a2.111,2.111,0,0,0,2.049-.219,6.482,6.482,0,0,0,2.937-5.1,2.049,2.049,0,0,0-.827-1.865h0l-.546-.342,17.657-7.179a1.284,1.284,0,0,0,.683,1.031l-1.592,13.887v1.885a6.53,6.53,0,0,0-2.432,4.734,2.049,2.049,0,0,0,.915,1.919h0l1.844,1.175h.034a2.1,2.1,0,0,0,2.049-.219,6.469,6.469,0,0,0,2.937-5.089,2.049,2.049,0,0,0-.827-1.865h0l-1.872-1.189h0a1.558,1.558,0,0,0-.977-.212l2.049-14.474h0a4.438,4.438,0,0,0,1.291-.2h0l16.694,9.051-.956.608h0a2.1,2.1,0,0,0-.826,1.865,6.469,6.469,0,0,0,2.944,5.1,2.111,2.111,0,0,0,2.049.219h.041l1.837-1.175h0a2.049,2.049,0,0,0,.922-1.913,6.585,6.585,0,0,0-2.4-4.713V358.06l-15.567-9.249,8.2-2.049a5.888,5.888,0,0,0-.874,2.924,2.008,2.008,0,0,0,.915,1.913h0l1.844,1.175h.034a2.09,2.09,0,0,0,2.049-.212,6.489,6.489,0,0,0,2.937-5.1,2.049,2.049,0,0,0-.826-1.865h0l-1.872-1.182h0a1.714,1.714,0,0,0-1.366-.137v-.471l-1-.342-13.34.683V341.8a3.908,3.908,0,0,0,.417-.2,2.247,2.247,0,0,0,1.325-1.831V324.33h-8.948v15.423a2.193,2.193,0,0,0,1.3,1.831,4.313,4.313,0,0,0,.437.212v1.981l-9.638-2.083-.505.171v1.776h0l-1.865,1.189h0a2.118,2.118,0,0,0-.827,1.872,6.408,6.408,0,0,0,1.455,3.75l-9.317,4.2v2.24a4,4,0,0,0-.383.191,6.469,6.469,0,0,0-2.937,5.089A2.008,2.008,0,0,0,298.508,364.084Zm5.533-9.925,6.749-3.005h0l-9.119,4.064Zm11.933-7.589,1.366.738-.943.424a6.431,6.431,0,0,0-.4-1.189Zm5.649-.246-5.082,2.261h0Z",
    transform: "translate(-190.338 -204.672)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M361.9,357.329l1.475-2.534-1.919-1.216h0a2.049,2.049,0,0,0-2.131.178,6.468,6.468,0,0,0-2.937,5.089,2.008,2.008,0,0,0,.915,1.913h0l1.885,1.2,1.557-2.671A7.07,7.07,0,0,0,361.9,357.329Z",
    transform: "translate(-208.946 -213.873)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M362.137,355.541c1.626-.943,2.951-.191,2.958,1.68a6.489,6.489,0,0,1-2.937,5.1c-1.626.936-2.958.184-2.958-1.687a6.469,6.469,0,0,1,2.937-5.089Z",
    transform: "translate(-209.842 -214.436)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M316.622,356.269l-1.482-2.534,1.919-1.216h0a2.049,2.049,0,0,1,2.131.178,6.489,6.489,0,0,1,2.944,5.089,2.049,2.049,0,0,1-.922,1.913h0l-1.878,1.2-1.557-2.657A7.037,7.037,0,0,1,316.622,356.269Z",
    transform: "translate(-195.878 -213.537)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M316.888,354.483c-1.626-.936-2.951-.184-2.958,1.687a6.468,6.468,0,0,0,2.944,5.089c1.626.943,2.951.184,2.958-1.687a6.468,6.468,0,0,0-2.944-5.089Z",
    transform: "translate(-195.494 -214.102)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M332.767,348.93h5.464v9.426h0a1.366,1.366,0,0,1-.806,1.12,4.262,4.262,0,0,1-3.866,0,1.366,1.366,0,0,1-.8-1.127h0Z",
    transform: "translate(-201.462 -212.469)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M355.117,352.8v2.247l-14.337,3.613v-4.754Z",
    transform: "translate(-204.004 -213.696)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M355.117,352.642l-1-.342-13.34.7v.745Z",
    transform: "translate(-204.004 -213.537)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M363.192,380.789l-1.482-2.534,1.919-1.216h0a2.049,2.049,0,0,1,2.131.178,6.475,6.475,0,0,1,2.944,5.089,2.049,2.049,0,0,1-.922,1.913h0l-1.878,1.2-1.557-2.671A6.905,6.905,0,0,1,363.192,380.789Z",
    transform: "translate(-210.638 -221.309)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M363.458,379c-1.626-.943-2.951-.184-2.958,1.68a6.469,6.469,0,0,0,2.944,5.1c1.626.936,2.951.184,2.958-1.687A6.455,6.455,0,0,0,363.458,379Z",
    transform: "translate(-210.254 -221.871)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M333.367,390.159l1.475-2.534-1.919-1.216h0a2.049,2.049,0,0,0-2.131.178,6.483,6.483,0,0,0-2.937,5.089,2.049,2.049,0,0,0,.915,1.919h0l1.885,1.2,1.557-2.664A7.2,7.2,0,0,0,333.367,390.159Z",
    transform: "translate(-199.905 -224.278)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M333.634,388.4c1.626-.936,2.951-.184,2.958,1.687a6.469,6.469,0,0,1-2.937,5.089c-1.632.943-2.958.191-2.964-1.687A6.516,6.516,0,0,1,333.634,388.4Z",
    transform: "translate(-200.806 -224.852)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M303.073,375.656l1.475-2.534-1.906-1.223h0a2.049,2.049,0,0,0-2.131.178,6.469,6.469,0,0,0-2.937,5.089,2.008,2.008,0,0,0,.915,1.913h0l1.885,1.2,1.557-2.671a7.069,7.069,0,0,0,1.141-1.954Z",
    transform: "translate(-190.307 -219.68)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M303.3,373.871c1.626-.943,2.951-.191,2.958,1.68a6.482,6.482,0,0,1-2.937,5.1c-1.633.936-2.958.184-2.964-1.687a6.5,6.5,0,0,1,2.944-5.089Z",
    transform: "translate(-191.193 -220.245)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M357.911,369.155V372.8l-19.2-10.376V357.4Z",
    transform: "translate(-203.348 -215.153)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M359.017,368.4,339.81,356.99l-1.1.28,19.2,11.755Z",
    transform: "translate(-203.348 -215.024)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M367.927,377.331l-1.107.628v-3.641l1.107-.628Z",
    transform: "translate(-212.257 -220.316)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M335.736,357.4,333.4,375.959v3.32l2.336-16.653Z",
    transform: "translate(-201.665 -215.153)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 1.352,
    height: 3.32,
    transform: "translate(130.382 160.805)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M331.42,375.959l2.124-18.559h1.564l-2.336,18.559Z",
    transform: "translate(-201.038 -215.153)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M303.56,365.383v3.484l19.952-8.115V356.49Z",
    transform: "translate(-192.208 -214.865)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M302.42,372.247l.779.512v-3.484l-.779-.505Z",
    transform: "translate(-191.846 -218.757)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M305.569,363.884l-2.37,1.059-.779-.505,20.731-9.337v.949Z",
    transform: "translate(-191.846 -214.424)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M317.98,350.02V352.3l5.82,3.122,4.283-1.933v-.936Z",
    transform: "translate(-196.778 -212.814)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M317.98,349.934l.464-.184,9.638,2.083v.635Z",
    transform: "translate(-196.778 -212.729)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M330.23,324.33h8.948v15.423h0a2.247,2.247,0,0,1-1.325,1.831,6.954,6.954,0,0,1-6.325,0,2.193,2.193,0,0,1-1.3-1.831h0Z",
    transform: "translate(-200.66 -204.672)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M278.027,266.933a5.71,5.71,0,0,0,1.933,1.831l36.475,19.378a8.565,8.565,0,0,0,7.862.075l25.553-12.944a12.917,12.917,0,0,0,6.639-8.2l12.3-45.546.622.191a4.993,4.993,0,0,0,1.612.246h.068l-14.631,54.05a12.917,12.917,0,0,1-6.639,8.163l-25.553,12.944a8.545,8.545,0,0,1-7.862-.075l-36.475-19.378C276.32,275.635,275.978,270.061,278.027,266.933Z",
    transform: "translate(-183.717 -172.091)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M278.027,266.933a5.71,5.71,0,0,0,1.933,1.831l36.475,19.378a8.565,8.565,0,0,0,7.862.075l25.553-12.944a12.917,12.917,0,0,0,6.639-8.2l12.3-45.546.622.191a4.993,4.993,0,0,0,1.612.246h.068l-14.631,54.05a12.917,12.917,0,0,1-6.639,8.163l-25.553,12.944a8.545,8.545,0,0,1-7.862-.075l-36.475-19.378C276.32,275.635,275.978,270.061,278.027,266.933Z",
    transform: "translate(-183.717 -172.091)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M280.327,279.329l26.428-13.559,34.836,17.9c-1.134.273-2.281.505-3.415.731a26.07,26.07,0,0,0-8.648,2.862c-2.6,1.6-4.7,4.337-4.72,7.391l.936,7.186h0l-.813.41a8.566,8.566,0,0,1-7.862-.075L280.593,282.8a5.71,5.71,0,0,1-1.933-1.831A4.932,4.932,0,0,1,280.327,279.329Z",
    transform: "translate(-184.316 -186.112)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M280.327,279.329l26.428-13.559,34.836,17.9c-1.134.273-2.281.505-3.415.731a26.07,26.07,0,0,0-8.648,2.862c-2.6,1.6-4.7,4.337-4.72,7.391l.936,7.186h0l-.813.41a8.566,8.566,0,0,1-7.862-.075L280.593,282.8a5.71,5.71,0,0,1-1.933-1.831A4.932,4.932,0,0,1,280.327,279.329Z",
    transform: "translate(-184.316 -186.112)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M286.73,230.827s21.216,6.236,26.831.724c6.981-6.831,4.057-24.126,3.224-30.888s0-11.441,1.872-13.415,4.577-4.884,13.361-1.243c-8.88,4.57-10.034,26.318-7.22,35.048-6.974,7.172-6.5,18.286-6.626,23.443,0,0-18.128,4.426-27.6,9.624Z",
    transform: "translate(-186.874 -160.281)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M286.73,230.827s21.216,6.236,26.831.724c6.981-6.831,4.057-24.126,3.224-30.888s0-11.441,1.872-13.415,4.577-4.884,13.361-1.243c-8.88,4.57-10.034,26.318-7.22,35.048-6.974,7.172-6.5,18.286-6.626,23.443,0,0-18.128,4.426-27.6,9.624Z",
    transform: "translate(-186.874 -160.281)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M287.509,275.405l-4.344-2.343c0-11.933-1.762-10.758-5.048-15.437s1.749-7.6,5.546-5.512S288.991,260.446,287.509,275.405Z",
    transform: "translate(-183.807 -181.567)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M287.509,275.405l-4.344-2.343c0-11.933-1.762-10.758-5.048-15.437s1.749-7.6,5.546-5.512S288.991,260.446,287.509,275.405Z",
    transform: "translate(-183.807 -181.567)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M351.415,186.81s23.77,10.294,35.341,16.011l-.847,4.221L348,189.829a10.246,10.246,0,0,1,3.415-3.019Z",
    transform: "translate(-206.293 -161.087)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M351.415,186.81s23.77,10.294,35.341,16.011l-.847,4.221L348,189.829a10.246,10.246,0,0,1,3.415-3.019Z",
    transform: "translate(-206.293 -161.087)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M339.383,223.259c-2.4-7.452-1.913-24.385,3.811-32.029l37.9,17.213-8.661,43.422-13.729,8.2L332.75,246.715C332.921,241.544,332.408,230.431,339.383,223.259Z",
    transform: "translate(-201.459 -162.487)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M376.258,250.8c-.642-.369-1.168-.075-1.168.683a2.575,2.575,0,0,0,1.161,2.015c.642.369,1.168.068,1.168-.683a2.561,2.561,0,0,0-1.161-2.015Z",
    transform: "translate(-214.878 -181.316)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M367.668,245.746c-.642-.369-1.168-.075-1.168.683a2.561,2.561,0,0,0,1.161,2.008c.642.369,1.168.075,1.168-.683A2.555,2.555,0,0,0,367.668,245.746Z",
    transform: "translate(-212.156 -179.716)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M359.078,240.705c-.642-.376-1.161-.075-1.168.683a2.561,2.561,0,0,0,1.161,2.008c.642.376,1.168.075,1.168-.683a2.527,2.527,0,0,0-1.161-2.008Z",
    transform: "translate(-209.433 -178.117)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M350.458,235.656c-.642-.369-1.168-.075-1.168.683a2.555,2.555,0,0,0,1.161,2.049c.642.369,1.161.068,1.168-.683a2.562,2.562,0,0,0-1.161-2.049Z",
    transform: "translate(-206.701 -176.518)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408",
    transform: "translate(142.589 58.98)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M376.258,250.8c-.642-.369-1.168-.075-1.168.683a2.575,2.575,0,0,0,1.161,2.015c.642.369,1.168.068,1.168-.683a2.561,2.561,0,0,0-1.161-2.015Z",
    transform: "translate(-357.467 -240.296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M367.668,245.746c-.642-.369-1.168-.075-1.168.683a2.561,2.561,0,0,0,1.161,2.008c.642.369,1.168.075,1.168-.683A2.555,2.555,0,0,0,367.668,245.746Z",
    transform: "translate(-354.745 -238.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M359.078,240.705c-.642-.376-1.161-.075-1.168.683a2.561,2.561,0,0,0,1.161,2.008c.642.376,1.168.075,1.168-.683a2.527,2.527,0,0,0-1.161-2.008Z",
    transform: "translate(-352.022 -237.097)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M350.458,235.656c-.642-.369-1.168-.075-1.168.683a2.555,2.555,0,0,0,1.161,2.049c.642.369,1.161.068,1.168-.683a2.562,2.562,0,0,0-1.161-2.049Z",
    transform: "translate(-349.29 -235.498)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M350.893,271.416a26.07,26.07,0,0,1,8.648-2.862c1.141-.225,2.288-.458,3.415-.731a21.065,21.065,0,0,0,5.3-1.933c4.187-2.316,7-6.639,8.354-11.236s1.366-9.474,1.093-14.255-.874-9.563-.731-14.344c.082-2.787.505-5.765,2.391-7.821s5.082-2.732,7.923-2.384a15.944,15.944,0,0,1,2.732.642l1.257,1.475-.485,1.783L378.5,265.3a12.917,12.917,0,0,1-5.663,7.6c-.321.2-.642.389-.977.56l-24.74,12.534-.936-7.186C346.194,275.754,348.3,273.022,350.893,271.416Z",
    transform: "translate(-205.716 -170.263)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M350.893,271.416a26.07,26.07,0,0,1,8.648-2.862c1.141-.225,2.288-.458,3.415-.731a21.065,21.065,0,0,0,5.3-1.933c4.187-2.316,7-6.639,8.354-11.236s1.366-9.474,1.093-14.255-.874-9.563-.731-14.344c.082-2.787.505-5.765,2.391-7.821s5.082-2.732,7.923-2.384a15.944,15.944,0,0,1,2.732.642l1.257,1.475-.485,1.783L378.5,265.3a12.917,12.917,0,0,1-5.663,7.6c-.321.2-.642.389-.977.56l-24.74,12.534-.936-7.186C346.194,275.754,348.3,273.022,350.893,271.416Z",
    transform: "translate(-205.716 -170.263)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M353,264.6c9.051-2.582,17.944-2.917,21.223-9.419s3.511-15.471,1.872-31.066a23.665,23.665,0,0,1,.143-6.038c.963-5.84,4.474-8.333,8.511-8.395a15.71,15.71,0,0,1,10.826,4.1,4.9,4.9,0,0,1,1.366,1.762,2.1,2.1,0,0,1-.266,2.111,2.049,2.049,0,0,1-1.366.622h-.068a4.994,4.994,0,0,1-1.612-.246l-.622-.191c-1.107-.348-2.193-.765-3.32-1.038a7.24,7.24,0,0,0-4.1,0,4.337,4.337,0,0,0-2.616,2.917c-3.818,12.466,1.018,25.861-3.272,36.154-3.511,9.358-15.642,13.245-24.2,16.025h0a5.281,5.281,0,0,0,2.138-1.557A3.6,3.6,0,0,0,357.3,266a4.72,4.72,0,0,0-4.3-1.4Z",
    transform: "translate(-207.877 -168.334)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M353,264.6c9.051-2.582,17.944-2.917,21.223-9.419s3.511-15.471,1.872-31.066a23.665,23.665,0,0,1,.143-6.038c.963-5.84,4.474-8.333,8.511-8.395a15.71,15.71,0,0,1,10.826,4.1,4.9,4.9,0,0,1,1.366,1.762,2.1,2.1,0,0,1-.266,2.111,2.049,2.049,0,0,1-1.366.622h-.068a4.994,4.994,0,0,1-1.612-.246l-.622-.191c-1.107-.348-2.193-.765-3.32-1.038a7.24,7.24,0,0,0-4.1,0,4.337,4.337,0,0,0-2.616,2.917c-3.818,12.466,1.018,25.861-3.272,36.154-3.511,9.358-15.642,13.245-24.2,16.025h0a5.281,5.281,0,0,0,2.138-1.557A3.6,3.6,0,0,0,357.3,266a4.72,4.72,0,0,0-4.3-1.4Z",
    transform: "translate(-207.877 -168.334)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M343.043,296.442a13.519,13.519,0,0,1,2.316-4.057,6.954,6.954,0,0,1,3.962-2.343,4.72,4.72,0,0,1,4.283,1.366,3.6,3.6,0,0,1,.335,4.337A5.281,5.281,0,0,1,351.8,297.3a19.862,19.862,0,0,0-1.988.977,8.422,8.422,0,0,0-3.415,4.829,25.2,25.2,0,0,0-.792,5.99v.389l-4.242-2.357A25.957,25.957,0,0,1,343.043,296.442Z",
    transform: "translate(-204.177 -193.779)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M343.043,296.442a13.519,13.519,0,0,1,2.316-4.057,6.954,6.954,0,0,1,3.962-2.343,4.72,4.72,0,0,1,4.283,1.366,3.6,3.6,0,0,1,.335,4.337A5.281,5.281,0,0,1,351.8,297.3a19.862,19.862,0,0,0-1.988.977,8.422,8.422,0,0,0-3.415,4.829,25.2,25.2,0,0,0-.792,5.99v.389l-4.242-2.357A25.957,25.957,0,0,1,343.043,296.442Z",
    transform: "translate(-204.177 -193.779)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M372.773,207.459a4.9,4.9,0,0,0-1.366-1.762,15.464,15.464,0,0,0-7.3-3.709C352.493,196.257,328.832,186,328.832,186a7.889,7.889,0,0,0-.888.54,7.889,7.889,0,0,1,.888-.54c-8.784-3.641-11.489-.731-13.361,1.243s-2.732,6.66-1.872,13.415,3.757,24.037-3.224,30.888c-5.615,5.512-26.831-.724-26.831-.724-3.8-2.083-8.839.826-5.546,5.512s5.055,3.5,5.048,15.437L279.7,253.5a4.932,4.932,0,0,0-1.7,1.639c-2.049,3.115-1.708,8.688,1.933,10.758l36.475,19.378a8.545,8.545,0,0,0,7.862.075L349.822,272.4a12.917,12.917,0,0,0,6.639-8.163l14.631-54.05a2.049,2.049,0,0,0,1.366-.622,2.1,2.1,0,0,0,.314-2.111Zm-17.206,50.253c-.1.184-.2.362-.294.54C355.369,258.074,355.471,257.9,355.567,257.712Zm-.622,1.093c-.123.2-.253.389-.389.581A5.369,5.369,0,0,0,354.945,258.8ZM326.94,187.37q-.348.321-.683.683a8.716,8.716,0,0,1,.676-.683Zm.827-.683a7.994,7.994,0,0,0-.683.526,7.979,7.979,0,0,1,.676-.519Zm-2.35,2.336c.232-.307.471-.6.724-.881C325.915,188.422,325.676,188.716,325.416,189.023Zm-3.347,7.193a44.186,44.186,0,0,0-1.366,6.516,44.187,44.187,0,0,1,1.393-6.516Zm3.347-7.193c-.171.232-.342.471-.505.717A8.21,8.21,0,0,0,325.416,189.023Zm-.533.765c-.164.253-.321.505-.478.772.184-.266.328-.519.505-.772Zm-.485.779a25.6,25.6,0,0,0-2.329,5.635,25.6,25.6,0,0,1,2.357-5.635Zm-3.689,12.3c-.048.328-.082.683-.123.99.048-.328.1-.642.15-.984Zm-.143,1.216c-.034.314-.068.635-.1.956.055-.314.089-.628.123-.949Zm-.116,1.189c0,.328-.055.649-.075.977.048-.3.075-.642.1-.984Zm-.082,1.052c-.068,1.018-.1,2.049-.116,3.026.041-.99.082-2,.143-3.019Zm-.123,3.415Zm1.147,10.553a1.517,1.517,0,0,0-.068-.28A2.246,2.246,0,0,0,321.393,220.287Zm-.212-.861a2.116,2.116,0,0,0-.075-.348c.021.082.048.2.075.314Zm-.2-.922a2.5,2.5,0,0,0-.068-.383c.021.116.048.219.068.348Zm-.171-.984-.061-.4Zm-.15-1.052a3.824,3.824,0,0,0-.055-.389,1.472,1.472,0,0,1,.027.355Zm-.157-1.366-.041-.451Zm-.1-1.175a3.009,3.009,0,0,0-.034-.553c.014.157.021.348.034.526Zm-.068-1.134v0Zm-.041-1.148v-.683c-.014.219-.007.444,0,.656Zm15.027,43.326h0l-20.314-10.451h0Zm-11.031,21.475.813-.41,24.74-12.534a9.59,9.59,0,0,0,.977-.56c.294-.2.581-.383.854-.594a12.343,12.343,0,0,1-1.831,1.154Zm27.582-14.235a7.359,7.359,0,0,0,.683-.594c-.2.178-.437.376-.683.567Zm.977-.833c.2-.191.4-.4.594-.6-.191.178-.389.383-.594.574Zm1.366-1.53q-.239.307-.492.594.28-.314.512-.622Zm1.653-2.835c.061-.143.137-.287.191-.437a3.763,3.763,0,0,1-.171.41Z",
    transform: "translate(-183.709 -160.281)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M307.044,309c4.187-1.8,9.877-8.839,12.732-12.391,3.62-4.508,3.217-14.344,2.4-18.818L286.56,275c-1.018,9.754-9.979,16.141-9.979,16.141Z",
    transform: "translate(-183.657 -189.038)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M225.8,372.29c.137,3.292,0,7.152,0,7.152l1.913.109a4.618,4.618,0,0,1,4.1,3.046l.048.116a1.8,1.8,0,0,0,2.234,1.107h0a1.769,1.769,0,0,0,1.086-.943l1-8.251Z",
    transform: "translate(-167.562 -219.873)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M214.347,409.389c-5.007,2.131-12.671,2.555-15.847-2.555V408.2c3.176,5.109,10.84,4.693,15.847,2.555s3.907-5.628,8.395-7.514a12.2,12.2,0,0,0,4.378-2.732,13.523,13.523,0,0,1,.157-1.51,15.368,15.368,0,0,1-4.536,2.889C218.254,403.781,219.333,407.251,214.347,409.389Z",
    transform: "translate(-158.91 -228.338)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M227.268,389.3a7.207,7.207,0,0,1,0-2.951,1.578,1.578,0,0,0-.225-1.3l-.376-.369-.178,1.516a1.769,1.769,0,0,1-1.086.943,1.8,1.8,0,0,1-2.234-1.107l-.048-.116a4.617,4.617,0,0,0-4.1-3.046l-1.94-.109a1.407,1.407,0,0,0-1.366.861c-1.995,4.816-7.015,10.171-10.888,12.616-2.842-.061-6.359,2.3-6.359,5.164v.287c3.176,5.109,10.84,4.686,15.847,2.555s3.907-5.635,8.395-7.514a15.368,15.368,0,0,0,4.536-2.889A16.672,16.672,0,0,0,227.268,389.3Z",
    transform: "translate(-158.9 -223.19)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M223.486,396.411a.635.635,0,0,0,.888.075.628.628,0,0,0,.1-.874,7.247,7.247,0,0,0-6.537-2.869c-.266.328-.54.683-.82.977A6.981,6.981,0,0,1,223.486,396.411Z",
    transform: "translate(-164.811 -226.343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M226.272,393.137a.635.635,0,0,0,.888.082.628.628,0,0,0,.1-.874,7.616,7.616,0,0,0-6.831-2.944c-.239.355-.492.683-.751,1.066A7.072,7.072,0,0,1,226.272,393.137Z",
    transform: "translate(-165.623 -225.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M220.492,399.572a.635.635,0,0,0,.888.082.642.642,0,0,0,.1-.881,7.268,7.268,0,0,0-6.366-2.883c-.321.341-.649.683-.977.99A6.994,6.994,0,0,1,220.492,399.572Z",
    transform: "translate(-163.867 -227.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M204.859,402.489c-2.842-.061-6.359,2.3-6.359,5.164v.287c3.128,5.027,10.608,4.7,15.615,2.643C213.732,403.705,207.127,402.469,204.859,402.489Z",
    transform: "translate(-158.91 -229.444)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M217.295,402.591a.636.636,0,0,0,.99-.8,7.261,7.261,0,0,0-6.38-2.883c-.4.355-.8.683-1.2,1A7.063,7.063,0,0,1,217.295,402.591Z",
    transform: "translate(-162.78 -228.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M274.9,381.57c.143,3.285,0,7.152,0,7.152l1.913.109a4.631,4.631,0,0,1,4.1,3.046l.041.116a1.8,1.8,0,0,0,2.234,1.107h0a1.769,1.769,0,0,0,1.086-.943l.977-8.245Z",
    transform: "translate(-183.124 -222.814)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M263.447,418.666c-5.007,2.138-12.664,2.555-15.847-2.548v1.366c3.183,5.109,10.84,4.693,15.847,2.555s3.907-5.628,8.395-7.514a12.07,12.07,0,0,0,4.378-2.732c0-.4.089-.915.157-1.5a15.506,15.506,0,0,1-4.536,2.889C267.354,413.037,268.454,416.535,263.447,418.666Z",
    transform: "translate(-174.472 -231.283)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M276.368,398.583a7.043,7.043,0,0,1,0-2.951,1.571,1.571,0,0,0-.232-1.311l-.369-.362-.184,1.516a1.769,1.769,0,0,1-1.086.943,1.8,1.8,0,0,1-2.234-1.107l-.041-.116a4.631,4.631,0,0,0-4.1-3.046l-1.94-.109a1.407,1.407,0,0,0-1.366.861c-1.995,4.816-7.015,10.171-10.888,12.616-2.842-.061-6.359,2.3-6.359,5.164v.287c3.183,5.1,10.84,4.686,15.847,2.548s3.907-5.628,8.395-7.514a15.5,15.5,0,0,0,4.536-2.889,16.392,16.392,0,0,0,.02-4.529Z",
    transform: "translate(-174.462 -226.132)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M272.589,405.691a.635.635,0,0,0,.888.075.622.622,0,0,0,.1-.874,7.24,7.24,0,0,0-6.537-2.869c-.266.328-.54.683-.813.977A6.967,6.967,0,0,1,272.589,405.691Z",
    transform: "translate(-180.376 -229.284)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M275.372,402.417a.635.635,0,0,0,.888.082.622.622,0,0,0,.1-.874,7.6,7.6,0,0,0-6.831-2.944c-.239.355-.492.683-.751,1.066A7.057,7.057,0,0,1,275.372,402.417Z",
    transform: "translate(-181.184 -228.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M269.6,408.852a.639.639,0,0,0,1-.8,7.254,7.254,0,0,0-6.366-2.882c-.321.342-.649.683-.977.99a6.987,6.987,0,0,1,6.346,2.691Z",
    transform: "translate(-179.432 -230.287)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M253.959,411.769c-2.842-.061-6.359,2.3-6.359,5.164v.287c3.135,5.027,10.615,4.693,15.622,2.643C262.832,412.985,256.234,411.742,253.959,411.769Z",
    transform: "translate(-174.472 -232.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M266.4,411.871a.636.636,0,1,0,.99-.8,7.247,7.247,0,0,0-6.38-2.883c-.4.355-.8.683-1.189,1A7.057,7.057,0,0,1,266.4,411.871Z",
    transform: "translate(-178.345 -231.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M243.747,350.646c-1.605,6.783-2.691,11.052-5.642,20.171,0,0-11.414,2.445-15.915-2.008L227.327,344Z",
    transform: "translate(-166.418 -210.906)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M286.456,356.58c-.43,6.96-.178,13.231-1.544,22.725,0,0-9.727,3.224-14.918-.4l-.854-16.571Z",
    transform: "translate(-181.299 -214.894)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M323.051,326.546l-2.131-1.236v15.048L273.1,368.008V355.392l-2.138,1.236-2.131-1.236v60.369l2.131,1.229,2.138-1.229V372.728l47.821-27.616v40.56l2.131,1.236,2.138-1.236V325.31Z",
    transform: "translate(-181.2 -204.983)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M144.809,300.657V288.041l-2.131,1.23-2.138-1.23V348.4l2.138,1.236,2.131-1.236V305.37l49.959-28.846v-2.288L192.637,273Z",
    transform: "translate(-140.54 -188.404)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M143.67,296.25v60.369l2.131-1.236V295.02Z",
    transform: "translate(-141.532 -195.383)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M142.678,296.25v60.369l-2.138-1.236V295.02Z",
    transform: "translate(-140.54 -195.383)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M146.79,305.944,196.749,277.1V274.81L146.79,303.649Z",
    transform: "translate(-142.521 -188.977)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M146.79,300.657,194.618,273l2.131,1.236L146.79,303.075Z",
    transform: "translate(-142.521 -188.404)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M348.21,326.546v60.362l2.138-1.236V325.31Z",
    transform: "translate(-206.359 -204.983)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M347.221,326.546v60.362l-2.131-1.236V325.31Z",
    transform: "translate(-205.37 -204.983)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M271.95,370.586v60.362l2.138-1.23V369.35Z",
    transform: "translate(-182.189 -218.941)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M270.961,370.586v60.362l-2.131-1.23V369.35Z",
    transform: "translate(-181.2 -218.941)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M275.08,380.281l49.952-28.846v-2.3L275.08,377.986Z",
    transform: "translate(-183.181 -212.536)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M275.08,374.99,322.9,347.34l2.131,1.23L275.08,377.415Z",
    transform: "translate(-183.181 -211.965)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409",
    transform: "translate(87.63 120.327)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M348.21,326.546v60.362l2.138-1.236V325.31Z",
    transform: "translate(-293.989 -325.31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M347.221,326.546v60.362l-2.131-1.236V325.31Z",
    transform: "translate(-293 -325.31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M271.95,370.586v60.362l2.138-1.23V369.35Z",
    transform: "translate(-269.819 -339.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M270.961,370.586v60.362l-2.131-1.23V369.35Z",
    transform: "translate(-268.83 -339.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M275.08,380.281l49.952-28.846v-2.3L275.08,377.986Z",
    transform: "translate(-270.811 -332.863)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M275.08,374.99,322.9,347.34l2.131,1.23L275.08,377.415Z",
    transform: "translate(-270.811 -332.292)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    transform: "translate(0 84.596)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M143.67,296.25v60.369l2.131-1.236V295.02Z",
    transform: "translate(-141.532 -279.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M142.678,296.25v60.369l-2.138-1.236V295.02Z",
    transform: "translate(-140.54 -279.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M146.79,305.944,196.749,277.1V274.81L146.79,303.649Z",
    transform: "translate(-142.521 -273.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M146.79,300.657,194.618,273l2.131,1.236L146.79,303.075Z",
    transform: "translate(-142.521 -273)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M284.522,292.717,194.768,240.88,140.54,272.205v5.656L230.3,329.869l54.228-31.318v-5.84Z",
    transform: "translate(-140.54 -178.224)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M230.3,324.042,140.54,272.205l54.228-31.325,89.761,51.837Z",
    transform: "translate(-140.54 -178.224)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M230.3,344.4,140.54,292.4V286.74L230.3,338.577Z",
    transform: "translate(-140.54 -192.758)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M271.95,348.085l54.228-31.325v5.84L271.95,353.918Z",
    transform: "translate(-182.189 -202.273)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M230.3,324.042,140.54,272.205l54.228-31.325,89.761,51.837Z",
    transform: "translate(-140.54 -178.224)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M271.95,348.085l54.228-31.325v5.84L271.95,353.918Z",
    transform: "translate(-182.189 -202.273)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M230.3,344.4,140.54,292.4V286.74L230.3,338.577Z",
    transform: "translate(-140.54 -192.758)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M203.955,287.162l22.124-12.855a5,5,0,0,1,4.542,0l36.5,21.079a1.646,1.646,0,0,1,.936,1.25h0v1.4h0a.861.861,0,0,1,0,.294,1.592,1.592,0,0,1-.15.307v.034a1.878,1.878,0,0,1-.273.307h0a2.665,2.665,0,0,1-.4.294l-22.213,12.9a3.318,3.318,0,0,1-.635.28l-.246.075-.321.082-.4.068h-1.332a4.351,4.351,0,0,1-.519-.089h-.1c-.15-.041-.3-.082-.444-.137h-.075a3.271,3.271,0,0,1-.492-.232l-36.5-21.072a2.814,2.814,0,0,1-.417-.294c-.041-.034-.061-.075-.1-.116a2.624,2.624,0,0,1-.191-.2.683.683,0,0,1-.068-.143,1.492,1.492,0,0,1-.109-.2v-.15a1.073,1.073,0,0,1-.034-.2v-1.3A1.6,1.6,0,0,1,203.955,287.162Z",
    transform: "translate(-160.349 -188.645)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M268.06,303.478a1.12,1.12,0,0,1-.041.4h0a1.468,1.468,0,0,1-.15.314v.034a1.846,1.846,0,0,1-.273.3h0a2.64,2.64,0,0,1-.4.287l-22.172,12.91a4.463,4.463,0,0,1-.635.28l-.246.068a2.45,2.45,0,0,1-.321.082,3.688,3.688,0,0,1-.4.068h-.089a4.872,4.872,0,0,1-.546,0h-.082a4.682,4.682,0,0,1-.54,0h-.075a2.66,2.66,0,0,1-.519-.089h-.1c-.15-.034-.3-.082-.444-.13h-.075a3.274,3.274,0,0,1-.492-.232l-36.5-21.079a2.786,2.786,0,0,1-.417-.287c-.041-.041-.061-.082-.1-.116a1.847,1.847,0,0,1-.191-.212.636.636,0,0,1-.068-.137,1.244,1.244,0,0,1-.109-.212v-.15a1.072,1.072,0,0,1-.034-.2v1.3a1.072,1.072,0,0,0,.034.2v.15a1.491,1.491,0,0,0,.109.2.684.684,0,0,0,.068.143,2.625,2.625,0,0,0,.191.2c.041.041.061.082.1.116a2.812,2.812,0,0,0,.417.294l36.5,21.038a3.277,3.277,0,0,0,.492.232h.075c.143.055.294.1.444.137h.1a4.338,4.338,0,0,0,.519.089h1.332l.4-.068.321-.082.246-.075a3.317,3.317,0,0,0,.635-.28l22.124-12.855a2.665,2.665,0,0,0,.4-.294h0a1.876,1.876,0,0,0,.273-.307v-.034a1.589,1.589,0,0,0,.15-.307h0a.861.861,0,0,0,0-.294h0v-1.4Z",
    transform: "translate(-160.349 -195.494)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M207.54,291.89,243,312.382l.137.061h.075a1.886,1.886,0,0,0,.28.082l.2.041h.84a1.365,1.365,0,0,0,.232-.041,1.843,1.843,0,0,0,.287-.075.985.985,0,0,0,.246-.1l11.407-6.632L220.081,284.54Z",
    transform: "translate(-161.775 -192.061)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M261.23,325.64Z",
    transform: "translate(-178.792 -205.087)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M253.681,286.99l-6.673,3.921a.683.683,0,0,0,0,1.168l9.973,5.758a1.113,1.113,0,0,0,1.12,0l6.673-3.921a.683.683,0,0,0,0-1.168L254.8,286.99A1.113,1.113,0,0,0,253.681,286.99Z",
    transform: "translate(-174.18 -192.79)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M207.54,291.89,243,312.382l.137.061h.075a1.886,1.886,0,0,0,.28.082l.2.041h.84a1.365,1.365,0,0,0,.232-.041,1.843,1.843,0,0,0,.287-.075.985.985,0,0,0,.246-.1l11.407-6.632L220.081,284.54Z",
    transform: "translate(-161.775 -192.061)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M253.681,286.99l-6.673,3.921a.683.683,0,0,0,0,1.168l9.973,5.758a1.113,1.113,0,0,0,1.12,0l6.673-3.921a.683.683,0,0,0,0-1.168L254.8,286.99A1.113,1.113,0,0,0,253.681,286.99Z",
    transform: "translate(-174.18 -192.79)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M250.021,267.643c-2.678,3.88,3.689,9.454,6.407,8.108S255.629,264.767,250.021,267.643Z",
    transform: "translate(-175.035 -186.537)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M250.021,267.643c-2.678,3.88,3.689,9.454,6.407,8.108S255.629,264.767,250.021,267.643Z",
    transform: "translate(-175.035 -186.537)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M264.063,215.984l-7.329,21.954L240.34,250.772a7.063,7.063,0,0,1-3.272.505l-6.578-.54a3.73,3.73,0,0,0-2.206.519l-3.757,2.281a4.009,4.009,0,0,0-1,.861l-1.844,2.186a1.366,1.366,0,0,0,.253,2.015l1.154.833a4.146,4.146,0,0,0,4.262.328l2.91-1.469,6.018.683v1.571l-1.626,1.4a1.735,1.735,0,0,0,.034,2.664h0s4.03-1.189,7.671-7.029l19.249-9.508a13.661,13.661,0,0,0,6.94-8.033l10.929-33.661-4.3.54A13.463,13.463,0,0,0,264.063,215.984Z",
    transform: "translate(-166.153 -167.289)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M286.561,204.786a14.891,14.891,0,0,0-12.2,10.014l-7.2,21.557-9.262,7.261a7.165,7.165,0,0,1,5.465,10.055l10.389-5.137a15.116,15.116,0,0,0,7.637-8.832L293,204Z",
    transform: "translate(-177.736 -166.535)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M260.75,265.654A7.35,7.35,0,0,0,255.5,262l-5.178,4.044a6.448,6.448,0,0,1,6.407,8.108l4.249-2.1a7.363,7.363,0,0,0-.225-6.4Z",
    transform: "translate(-175.334 -184.917)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M286.561,204.786a14.891,14.891,0,0,0-12.2,10.014l-7.2,21.557-9.262,7.261a7.165,7.165,0,0,1,5.465,10.055l10.389-5.137a15.116,15.116,0,0,0,7.637-8.832L293,204Z",
    transform: "translate(-177.736 -166.535)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M260.75,265.654A7.35,7.35,0,0,0,255.5,262l-5.178,4.044a6.448,6.448,0,0,1,6.407,8.108l4.249-2.1a7.363,7.363,0,0,0-.225-6.4Z",
    transform: "translate(-175.334 -184.917)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M271.44,250.536c4.638.1,6.831,2.493,7.418,3.689.212-6.919-6.872-5.328-6.872-5.328Z",
    transform: "translate(-182.028 -180.714)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M195.387,255.406h0l.874-.437h0a1.079,1.079,0,0,1,.977.061L233.993,276.4a4.419,4.419,0,0,1,2.152,3.142l3.777,24.03a1.086,1.086,0,0,1-.615,1.161h0l-.847.417h0a1.1,1.1,0,0,1-.943-.075l-36.755-21.373a4.419,4.419,0,0,1-2.152-3.142l-3.777-24.03a1.086,1.086,0,0,1,.553-1.127Z",
    transform: "translate(-157.743 -182.661)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M223.7,287.62a8.094,8.094,0,0,1,3.648,5.253c.239,1.872-1,2.568-2.78,1.544a8.135,8.135,0,0,1-3.648-5.253C220.677,287.285,221.92,286.6,223.7,287.62Z",
    transform: "translate(-166.005 -192.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M239.441,303.941l-3.777-24.03a4.44,4.44,0,0,0-2.152-3.142L196.757,255.4a1.086,1.086,0,0,0-1.107,0h0l.874-.437h0a1.079,1.079,0,0,1,.977.061l36.755,21.373a4.419,4.419,0,0,1,2.152,3.142l3.777,24.03a1.086,1.086,0,0,1-.615,1.161h0l-.847.417h0A1.1,1.1,0,0,0,239.441,303.941Z",
    transform: "translate(-158.007 -182.658)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M299.762,204.7l-3.217.335a7.9,7.9,0,0,0-5.786,3.5c-3.347,5.109-4.911,12.978-4.016,21.475.683,6.469,1.168,12.9-2.609,22.507-1.366,3.415.731,7.309,4.146,8.668,10.826,4.31,26.291,2.391,34.3-.232a4.836,4.836,0,0,0,2.937-6.53s-3.005-16.557-2.425-17.9c1.318-3.074,1.633-10.5,1.954-15.178a24.447,24.447,0,0,0-2.555-12.042l-12.3-4.6Z",
    transform: "translate(-185.917 -166.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M306.657,181.24a5.9,5.9,0,0,0,2.5,2,3.128,3.128,0,0,0,4.4-3.326,4.857,4.857,0,0,0,3.333-3.019,5.519,5.519,0,0,0-.423-4.693,9.41,9.41,0,0,0,4.44-4.781c.745-2.152-.15-4.952-2.138-5.806a4.242,4.242,0,0,0,.758-4.877,3.579,3.579,0,0,0-4.242-1.824,5.826,5.826,0,0,0-3.374-4.658,5.341,5.341,0,0,0-5.512.84,3.067,3.067,0,0,0-2.316-1.585,2.93,2.93,0,0,0-2.541,1.107,4.242,4.242,0,0,0-4.74-1.182,7.862,7.862,0,0,0-3.852,3.7,3.245,3.245,0,0,0-3.313.178A3.859,3.859,0,0,0,288,156.432a3.982,3.982,0,0,0,1.571,3.21,2.821,2.821,0,0,0-1.68,2.179,2.978,2.978,0,0,0,.936,2.657,2.473,2.473,0,0,0,2.6.4c2.814,3.046,7.766,3.019,10.881,5.7a10.929,10.929,0,0,1,2.978,4.686C305.892,177.053,305.523,179.785,306.657,181.24Z",
    transform: "translate(-187.231 -149.151)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M317.179,192.8v8.367a3.955,3.955,0,0,1-1.366,2.971,11.23,11.23,0,0,1-8,2.732,2.835,2.835,0,0,1-1.667-.512,2.193,2.193,0,0,1-.533-2.275,4.392,4.392,0,0,1,.608-1.229,3.812,3.812,0,0,0,.683-2.124V192.8Z",
    transform: "translate(-192.821 -162.985)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M311.74,199.562a22.644,22.644,0,0,1-4.16.82V192.8h10.246v1.783a8.244,8.244,0,0,1-.84,1.469,10.246,10.246,0,0,1-5.246,3.511Z",
    transform: "translate(-193.482 -162.985)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M318.668,176.129a3.313,3.313,0,0,0-2.637.772,10.073,10.073,0,0,0-1.872,2.172,3.211,3.211,0,0,1-.915.977,1.107,1.107,0,0,1-1.264,0,1.653,1.653,0,0,1-.362-1.366l.164-3.5a1.407,1.407,0,0,0-.779-1.3,3.415,3.415,0,0,1-1.564-1.8c-.048-.123-.082-.239-.123-.362a2.923,2.923,0,0,1-2.111.328,2.985,2.985,0,0,1-1.844-1.3,2.138,2.138,0,0,1-1.619,1.059,2.049,2.049,0,0,1-1.721-.792,3.675,3.675,0,0,1-6.038-.055,3.859,3.859,0,0,1-3.6-.355,43.032,43.032,0,0,0,1.148,16.066,13.224,13.224,0,0,0,1.325,3.415,5.574,5.574,0,0,0,2.732,2.4,8.523,8.523,0,0,0,4.481,0,22.683,22.683,0,0,0,7.883-2.418c2.37-1.428,4.235-4.016,4.01-6.776a4.526,4.526,0,0,0,7-3.579C321.038,178.158,320.15,176.436,318.668,176.129Z",
    transform: "translate(-188.572 -155.952)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M302.412,182.03l-3.142,5.287,3.743.7Z",
    transform: "translate(-190.848 -159.572)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M308.678,193.47l-2.848,1.366a1.865,1.865,0,0,0,2.158.615,1.674,1.674,0,0,0,.69-1.981Z",
    transform: "translate(-192.927 -163.197)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M308.678,193.47l-2.848,1.366a1.865,1.865,0,0,0,2.158.615,1.674,1.674,0,0,0,.69-1.981Z",
    transform: "translate(-192.927 -163.197)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M307.58,195.791a1.673,1.673,0,0,0,.99-.1,1.51,1.51,0,0,0,.765-1.5,1.762,1.762,0,0,0-1.127.389A1.81,1.81,0,0,0,307.58,195.791Z",
    transform: "translate(-193.482 -163.429)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M310.817,181.89a1.066,1.066,0,1,1-.388-.73,1.072,1.072,0,0,1,.388.73Z",
    transform: "translate(-193.829 -159.22)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M297.607,182.711a1.072,1.072,0,1,1-.388-.725A1.072,1.072,0,0,1,297.607,182.711Z",
    transform: "translate(-189.643 -159.48)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M295.359,176.978l-2.206,1.885a1.537,1.537,0,0,1,.294-1.728A1.831,1.831,0,0,1,295.359,176.978Z",
    transform: "translate(-188.863 -157.908)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M309.85,175.346l2.534,1.407a1.523,1.523,0,0,0-.628-1.633,1.817,1.817,0,0,0-1.906.225Z",
    transform: "translate(-194.201 -157.327)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M339.065,261.7c-3.586,3.518-13.8,8.149-20.745,5.642-1.612-21.045-.137-54.283,2.671-62.643l12.3,4.57c7.3,12.459,2.452,32.855,2.452,32.855a72.606,72.606,0,0,0,3.326,19.577Z",
    transform: "translate(-196.675 -166.757)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M339.065,261.7c-3.586,3.518-13.8,8.149-20.745,5.642-1.612-21.045-.137-54.283,2.671-62.643l12.3,4.57c7.3,12.459,2.452,32.855,2.452,32.855a72.606,72.606,0,0,0,3.326,19.577Z",
    transform: "translate(-196.675 -166.757)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M325.863,223.491l-4.385-5.1,3.538-2.452a2.049,2.049,0,0,0,.628-2.657l-4.652-8.586c-1.8,5.369-3.053,21-3.292,37.063l8.4-15.984A2.049,2.049,0,0,0,325.863,223.491Z",
    transform: "translate(-196.689 -166.757)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M325.863,223.491l-4.385-5.1,3.538-2.452a2.049,2.049,0,0,0,.628-2.657l-4.652-8.586c-1.8,5.369-3.053,21-3.292,37.063l8.4-15.984A2.049,2.049,0,0,0,325.863,223.491Z",
    transform: "translate(-196.689 -166.757)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M298.7,204.548c-2.083,2.568-9.037,10.758-9.959,40.929-.239,7.862-3.969,17.322-3.969,17.322l-5.212-7.445s5.922-7.288,5.922-19.337-2.22-16.291,1.366-23.907,7.643-7.37,8.839-7.514l3.012-.376Z",
    transform: "translate(-184.601 -166.604)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M298.7,204.548c-2.083,2.568-9.037,10.758-9.959,40.929-.239,7.862-3.969,17.322-3.969,17.322l-5.212-7.445s5.922-7.288,5.922-19.337-2.22-16.291,1.366-23.907,7.643-7.37,8.839-7.514l3.012-.376Z",
    transform: "translate(-184.601 -166.604)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M301.741,204.18l-8.88,7.418a2.049,2.049,0,0,0-.519,2.493l1,1.988-3.265,3.5a3.415,3.415,0,0,0-.861,2.944l2.924,16.038c1.68-24.542,7.7-31.66,9.617-34.023Z",
    transform: "translate(-187.643 -166.592)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M301.741,204.18l-8.88,7.418a2.049,2.049,0,0,0-.519,2.493l1,1.988-3.265,3.5a3.415,3.415,0,0,0-.861,2.944l2.924,16.038c1.68-24.542,7.7-31.66,9.617-34.023Z",
    transform: "translate(-187.643 -166.592)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M314.429,211.39l-12.937,38.88-23.067,8.962a7.93,7.93,0,0,1-3.709.574l-6.2-1.079a4.173,4.173,0,0,0-2.5.587l-4.276,2.589a4.779,4.779,0,0,0-1.141.977l-2.09,2.479a1.564,1.564,0,0,0,.287,2.288l1.311.943a4.706,4.706,0,0,0,4.836.376l3.306-1.667,1.523.362a15.451,15.451,0,0,0,9.939-.949h0l25.02-5.055a11.1,11.1,0,0,0,8.122-7s11.96-28.374,9.133-34.788C320.761,217.087,314.429,211.39,314.429,211.39Z",
    transform: "translate(-177.811 -168.877)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M323.651,211.39,310.3,249.826l-23.067,8.825c4.3,2.4,4.522,7.773,4.1,8.408l24.413-5.109a9.5,9.5,0,0,0,6.94-5.943l9.8-25.956c4.242-11.653-1.919-15.936-8.784-18.627Z",
    transform: "translate(-187.032 -168.877)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M323.651,211.39,310.3,249.826l-23.067,8.825c4.3,2.4,4.522,7.773,4.1,8.408l24.413-5.109a9.5,9.5,0,0,0,6.94-5.943l9.8-25.956c4.242-11.653-1.919-15.936-8.784-18.627Z",
    transform: "translate(-187.032 -168.877)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M296.671,281.387a9.153,9.153,0,0,0-3.217-4.317l-6.264,2.4c4.3,2.4,4.522,7.773,4.1,8.408L296.9,286.7A9.208,9.208,0,0,0,296.671,281.387Z",
    transform: "translate(-187.019 -189.694)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M321,266.7c4.242.055,7.2,1.9,7.65,3.238-.724-6.366-6.96-5.232-6.96-5.232Z",
    transform: "translate(-197.735 -185.749)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M271.218,322.41l-6.769-.41-6.769.41,1.68,11.885h0a2.787,2.787,0,0,0,1.551,1.974,7.855,7.855,0,0,0,7.09,0,2.732,2.732,0,0,0,1.51-1.974h0Z",
    transform: "translate(-177.666 -203.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M271.434,317.72h-.874a5.466,5.466,0,0,0-1.243-.963,11.154,11.154,0,0,0-10.123,0,5.465,5.465,0,0,0-1.236.963h-.847v1.967h0a3.533,3.533,0,0,0,2.111,2.937,11.168,11.168,0,0,0,10.13,0,3.607,3.607,0,0,0,2.083-2.937h0Z",
    transform: "translate(-177.486 -201.887)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M269.334,313.876a11.154,11.154,0,0,0-10.123,0c-2.794,1.619-2.773,4.249,0,5.867a11.168,11.168,0,0,0,10.123-.02C272.142,318.125,272.128,315.5,269.334,313.876Z",
    transform: "translate(-177.49 -200.974)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M269.334,313.876a11.154,11.154,0,0,0-10.123,0c-2.794,1.619-2.773,4.249,0,5.867a11.168,11.168,0,0,0,10.123-.02C272.142,318.125,272.128,315.5,269.334,313.876Z",
    transform: "translate(-177.49 -200.974)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M270.776,316.217h0l-.5-1.735h-.827c-.13-.089-.266-.178-.41-.26a9.467,9.467,0,0,0-8.586,0,4.671,4.671,0,0,0-.41.26h-.8l-.444,1.537a.164.164,0,0,0,0,.055l-.048.143h0c-.246,1.052.328,2.158,1.735,2.971a9.467,9.467,0,0,0,8.586,0C270.476,318.375,271.036,317.269,270.776,316.217Z",
    transform: "translate(-177.989 -201.143)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M268.937,311.992a8.723,8.723,0,0,0-7.889,0c-2.165,1.264-2.158,3.306,0,4.57a8.668,8.668,0,0,0,7.883,0C271.13,315.3,271.116,313.256,268.937,311.992Z",
    transform: "translate(-178.22 -200.463)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M268.937,311.992a8.723,8.723,0,0,0-7.889,0c-2.165,1.264-2.158,3.306,0,4.57a8.668,8.668,0,0,0,7.883,0C271.13,315.3,271.116,313.256,268.937,311.992Z",
    transform: "translate(-178.22 -200.463)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M261.876,313.618a7.828,7.828,0,0,1,7.029,0,2.3,2.3,0,0,1,1.182,1.3.914.914,0,0,0,.034-.239,2.049,2.049,0,0,0-1.216-1.551,7.828,7.828,0,0,0-7.029,0c-.758.444-1.188,1-1.188,1.53a1.5,1.5,0,0,0,0,.246,2.261,2.261,0,0,1,1.189-1.291Z",
    transform: "translate(-178.618 -200.859)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M261.876,313.618a7.828,7.828,0,0,1,7.029,0,2.3,2.3,0,0,1,1.182,1.3.914.914,0,0,0,.034-.239,2.049,2.049,0,0,0-1.216-1.551,7.828,7.828,0,0,0-7.029,0c-.758.444-1.188,1-1.188,1.53a1.5,1.5,0,0,0,0,.246,2.261,2.261,0,0,1,1.189-1.291Z",
    transform: "translate(-178.618 -200.859)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M261.919,316.409a7.275,7.275,0,0,0,3.518.833h0a7.145,7.145,0,0,0,3.5-.833,2.234,2.234,0,0,0,1.161-1.291,2.3,2.3,0,0,0-1.182-1.3,7.828,7.828,0,0,0-7.029,0,2.261,2.261,0,0,0-1.161,1.291A2.309,2.309,0,0,0,261.919,316.409Z",
    transform: "translate(-178.633 -201.075)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M261.919,316.409a7.275,7.275,0,0,0,3.518.833h0a7.145,7.145,0,0,0,3.5-.833,2.234,2.234,0,0,0,1.161-1.291,2.3,2.3,0,0,0-1.182-1.3,7.828,7.828,0,0,0-7.029,0,2.261,2.261,0,0,0-1.161,1.291A2.309,2.309,0,0,0,261.919,316.409Z",
    transform: "translate(-178.633 -201.075)",
    opacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePwd);
export default __webpack_public_path__ + "static/media/change-pwd.1f924eb7c2dc49f5c01798a23cebbd07.svg";
export { ForwardRef as ReactComponent };